import { Footer } from '../components/Footer';
import TestBanner from '../components/TestBanner';
import { useState, useEffect, useRef, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Switch } from '@/components/ui/switch';
import { Clock, HandHelping, Calendar, CheckCircle2, BarChart3, Settings, Plus, Edit, Trash2, Info, Building2, Cake, MessageSquare, Puzzle, UserRound, RefreshCw, Link, Copy, FileText, ClipboardCheck, Tag, Vote, BookOpen, Mic, Heart, Crown, UsersRound, Music, ScrollText, Flame, Repeat, Handshake, Home, Link2, Loader2, X, LogIn, ClipboardList, Plug, QrCode, KeyRound, Package, Droplets, BookOpenText, Sparkles, Users, Shield, HelpCircle, User } from 'lucide-react';
import { API, calcAge } from '@/lib/helpers';
import { useSettings } from '@/lib/useSettings';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useNotifications } from '@/hooks/useNotifications';
import { AdminDashboardHeader } from '@/components/admin/AdminDashboardHeader';

import DashboardTab from '@/components/admin/DashboardTab';
import PessoasTab from '@/components/admin/PessoasTab';
import EventosTab from '@/components/admin/EventosTab';
import PresencaTab from '@/components/admin/PresencaTab';
import RelatoriosTab from '@/components/admin/RelatoriosTab';
import AuditoriaTab from '@/components/admin/AuditoriaTab';
import ChangelogModal from '@/components/admin/ChangelogModal';
import PerguntasTab from '@/components/admin/PerguntasTab';
import VisitasTab from '@/components/admin/VisitasTab';
import VotacoesTab from '@/components/admin/VotacoesTab';
import ReunioesTab from '@/components/admin/ReunioesTab';
import LinksSettingsTab from '@/components/admin/LinksSettingsTab';
import OnboardingWizard from '@/components/OnboardingWizard';
import WhatsAppTab from '@/components/admin/WhatsAppTab';
import EscalasSettingsTab from '@/components/admin/EscalasSettingsTab';
import IntegracoesTab from '@/components/admin/IntegracoesTab';
import CestasBasicasTab from '@/components/CestasBasicasTab';
import BatismosTab from '@/components/BatismosTab';
import EbiTab from '@/components/admin/EbiTab';
import IgrejasGrupoTab from '@/components/admin/IgrejasGrupoTab';
import MovimentosTab from '@/components/admin/MovimentosTab';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const { settings, refreshSettings } = useSettings();
  const [user, setUser] = useState(null);
  const [overview, setOverview] = useState(null);
  const [auxiliares, setAuxiliares] = useState([]);
  const [pessoas, setPessoas] = useState([]);
  const [pessoasStats, setPessoasStats] = useState([]);
  const [pessoasLoading, setPessoasLoading] = useState(false);
  const [pessoasPendentes, setPessoasPendentes] = useState([]);
  const [pessoasRejeitadas, setPessoasRejeitadas] = useState([]);
  const [pendingUpdates, setPendingUpdates] = useState([]);
  const [events, setEvents] = useState([]);
  const [eventsStats, setEventsStats] = useState([]);
  const [frequencyReport, setFrequencyReport] = useState([]);
  const [auxiliarReport, setAuxiliarReport] = useState([]);
  const [eventsEngagement, setEventsEngagement] = useState([]);
  const [auditLogs, setAuditLogs] = useState([]);

  const [deleteConfirmDialog, setDeleteConfirmDialog] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [cancelRecurrence, setCancelRecurrence] = useState(true);
  const [settingsDialog, setSettingsDialog] = useState(false);
  const [ebiLinksDialog, setEbiLinksDialog] = useState(false);
  const [ebiAiDialog, setEbiAiDialog] = useState(false);
  const [auditoriaDialog, setAuditoriaDialog] = useState(false);
  const [changelogDialog, setChangelogDialog] = useState(false);
  const [onboardingOpen, setOnboardingOpen] = useState(false);
  const [settingsForm, setSettingsForm] = useState({ app_name: '', subtitle: '', terms_of_use: '', addons: {} });
  const [calendarStatus, setCalendarStatus] = useState({ connected: false, synced_count: 0 });
  const [calendarLoading, setCalendarLoading] = useState(false);
  const [calendarDisconnectDialog, setCalendarDisconnectDialog] = useState(false);
  const [calendarDisconnecting, setCalendarDisconnecting] = useState(false);
  const [savingSettings, setSavingSettings] = useState(false);
  const [settingsTab, setSettingsTab] = useState('geral');
  // WhatsApp Evolution states
  const [evoStatus, setEvoStatus] = useState(null);
  const [evoStatusLoading, setEvoStatusLoading] = useState(false);
  const [evoQrModal, setEvoQrModal] = useState(false);
  const [evoQrData, setEvoQrData] = useState(null);
  const [evoQrLoading, setEvoQrLoading] = useState(false);
  const [evoToggling, setEvoToggling] = useState(false);
  const [evoDeactivateDialog, setEvoDeactivateDialog] = useState(false);
  const [showMotivosInfo, setShowMotivosInfo] = useState(false);
  const [showTiposInfo, setShowTiposInfo] = useState(false);
  const [activeSection, setActiveSection] = useState(location.state?.activeSection || 'dashboard');
  const [churchSlug, setChurchSlug] = useState(null);
  const [slugCadastro, setSlugCadastro] = useState(null);
  const [slugPerguntas, setSlugPerguntas] = useState(null);
  const [slugVisitas, setSlugVisitas] = useState(null);
  const [slugAtualizar, setSlugAtualizar] = useState(null);
  const [slugAgenda, setSlugAgenda] = useState(null);
  const [isImpersonating, setIsImpersonating] = useState(false);
  const [pendingEditPessoaId, setPendingEditPessoaId] = useState(null);

  // Motivos de inativacao
  const [motivos, setMotivos] = useState([]);
  const [motivoForm, setMotivoForm] = useState({ nome: '' });
  const [editingMotivo, setEditingMotivo] = useState(null);
  const [motivoDialog, setMotivoDialog] = useState(false);

  // Perguntas
  const [perguntas, setPerguntas] = useState([]);
  const [visitas, setVisitas] = useState([]);

  // Tipos de Evento
  const [tiposEvento, setTiposEvento] = useState([]);
  const [tipoEventoForm, setTipoEventoForm] = useState({ nome: '', fechamento_valor: '', fechamento_unidade: 'horas', tem_presidencia: false, tem_participantes: false, tem_musicos: false, tem_recitativos: false, tem_ministerio: false, eh_material: false, disponivel_reuniao: false, permite_pessoa: false, permite_escala_servicos: false, escalas_servico_ids: [], recorrencia_ativa: false, recorrencia_inicio: '', recorrencia_dia_semana: '', recorrencia_horario: '', recorrencia_frequencia: 'semanal', recorrencia_antecedencia_valor: '', recorrencia_antecedencia_unidade: 'horas', notificar_whatsapp: false, notificacao_dias: [1, 2], notificacao_msg: '*CCBRJM*\n\nPaz de Deus! Passando para lembrar que temos evento {tempo}:\n\n📅 *{nome_evento}*\n🕐 {dia_semana}, {data} às {hora}\n\nContamos com sua presença! Deus te abençoe.' });
  const [notifMsgModal, setNotifMsgModal] = useState(false);
  const [editingTipoEvento, setEditingTipoEvento] = useState(null);
  const [tipoEventoDialog, setTipoEventoDialog] = useState(false);
  const [savingTipoEvento, setSavingTipoEvento] = useState(false);
  const [serviceFunctions, setServiceFunctions] = useState([]);

  // Slug editing
  const [slugDialog, setSlugDialog] = useState(null); // 'cadastro' | 'perguntas' | 'visitas' | 'atualizar' | 'agenda'

  // Backup import preview
  const [importPreview, setImportPreview] = useState(null); // { key, label, data, file }
  const [termsDialog, setTermsDialog] = useState(false);
  const [slugForm, setSlugForm] = useState('');

  // Administradores
  const [adminDialog, setAdminDialog] = useState(false);
  const [adminForm, setAdminForm] = useState({ name: '', email: '', phone: '' });
  const [editingAdmin, setEditingAdmin] = useState(null);
  const [savingAdmin, setSavingAdmin] = useState(false);
  const [sendingAdminPasswordId, setSendingAdminPasswordId] = useState(null);
  const [adminTempPasswordTarget, setAdminTempPasswordTarget] = useState(null);
  const [admins, setAdmins] = useState([]);
  const [groupChurchesData, setGroupChurchesData] = useState({ groups: [], churches: [] });
  const [groupChurchesLoaded, setGroupChurchesLoaded] = useState(false);

  // Notifications
  const { notifications, dismissed, dismiss: dismissNotifications, refresh: refreshNotifications, fetchNotifications } = useNotifications();
  const [bellOpen, setBellOpen] = useState(false);
  const onboardingShownRef = useRef(false);
  const activeAddons = useMemo(() => ({ ...(settings?.addons || {}), ...(user?.settings?.addons || {}) }), [settings?.addons, user?.settings?.addons]);
  const effectiveSettings = useMemo(() => ({ ...settings, ...(user?.settings || {}), addons: activeAddons }), [settings, user?.settings, activeAddons]);

  useEffect(() => {
    fetchAll();
    const params = new URLSearchParams(window.location.search);
    if (params.get('calendar_connected') === 'true') {
      toast.success('Google Calendar conectado com sucesso!');
      window.history.replaceState({}, '', window.location.pathname);
    }
    if (params.get('calendar_error')) {
      toast.error('Erro ao conectar Google Calendar: ' + params.get('calendar_error'));
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  // Refresh data and notifications when switching tabs
  useEffect(() => {
    if (activeSection === 'pessoas') fetchPessoasData();
    else if (activeSection === 'events' || activeSection === 'attendance' || activeSection === 'visitas' || activeSection === 'perguntas') fetchAll();
    fetchNotifications();
  }, [activeSection]);

  useEffect(() => {
    const gated = ['perguntas', 'visitas', 'votacoes', 'reunioes', 'whatsapp', 'cestas_basicas', 'batismos', 'movimentos'];
    if ((gated.includes(activeSection) && activeAddons && !activeAddons[activeSection]) || (activeSection.startsWith('ebi-') && activeAddons && !activeAddons.ebi)) {
      setActiveSection('pessoas');
    }
  }, [activeSection, activeAddons]);

  useEffect(() => {
    if (groupChurchesLoaded && activeSection === 'igrejas-grupo' && (groupChurchesData.groups || []).length === 0) {
      setActiveSection('dashboard');
    }
  }, [activeSection, groupChurchesData.groups, groupChurchesLoaded]);

  const fetchAll = async () => {
    try {
      const userResp = await fetch(`${API}/auth/me`, { credentials: 'include' });
      if (!userResp.ok) { navigate('/'); return; }
      const userData = await userResp.json();
      setUser(userData);
      if (userData.must_change_password) { navigate('/alterar-senha'); return; }
      if (userData.impersonated) {
        const originalToken = localStorage.getItem('original_admin_token');
        if (originalToken) {
          localStorage.removeItem('original_admin_token');
          await fetch(`${API}/auth/restore-session?token=${originalToken}`, { credentials: 'include' });
          const retryResp = await fetch(`${API}/auth/me`, { credentials: 'include' });
          if (retryResp.ok) {
            const retryData = await retryResp.json();
            setUser(retryData);
            setIsImpersonating(false);
          }
        } else {
          setIsImpersonating(true);
        }
      } else {
        setIsImpersonating(false);
      }
      if (userData.church_slug) setChurchSlug(userData.church_slug);
      if (userData.slug_cadastro) setSlugCadastro(userData.slug_cadastro);
      if (userData.slug_perguntas) setSlugPerguntas(userData.slug_perguntas);
      if (userData.slug_visitas) setSlugVisitas(userData.slug_visitas);
      if (userData.slug_atualizar) setSlugAtualizar(userData.slug_atualizar);
      if (userData.slug_agenda) setSlugAgenda(userData.slug_agenda);
      const skipOnboardingOnce = sessionStorage.getItem('skip_onboarding_once') === '1';
      if (!skipOnboardingOnce && !userData.onboarding_completed && !userData.impersonated && !onboardingShownRef.current) {
        onboardingShownRef.current = true;
        setOnboardingOpen(true);
      }

      const perguntasEnabled = !!userData?.settings?.addons?.perguntas || !!settings?.addons?.perguntas;
      const visitasEnabled = !!userData?.settings?.addons?.visitas || !!settings?.addons?.visitas;
      const skippedResponse = { ok: false, json: async () => [] };
      const [ovR, axR, psR, pnR, rjR, evR, frR, arR, lgR, stR, esR, eerR, pgR, vsR, adR, teR, puR, gcR] = await Promise.all([
        fetch(`${API}/reports/overview`, { credentials: 'include' }),
        fetch(`${API}/auxiliares/stats`, { credentials: 'include' }),
        fetch(`${API}/pessoas?status=aprovado`, { credentials: 'include' }),
        fetch(`${API}/pessoas?status=pendente`, { credentials: 'include' }),
        fetch(`${API}/pessoas?status=rejeitado`, { credentials: 'include' }),
        fetch(`${API}/events/stats`, { credentials: 'include' }),
        fetch(`${API}/reports/frequency`, { credentials: 'include' }),
        fetch(`${API}/reports/by-auxiliar`, { credentials: 'include' }),
        fetch(`${API}/audit-logs`, { credentials: 'include' }),
        fetch(`${API}/pessoas/stats`, { credentials: 'include' }),
        fetch(`${API}/events`, { credentials: 'include' }),
        fetch(`${API}/reports/events-engagement`, { credentials: 'include' }),
        perguntasEnabled ? fetch(`${API}/perguntas`, { credentials: 'include' }) : skippedResponse,
        visitasEnabled ? fetch(`${API}/visitas`, { credentials: 'include' }) : skippedResponse,
        fetch(`${API}/admins`, { credentials: 'include' }),
        fetch(`${API}/tipos-evento`, { credentials: 'include' }),
        fetch(`${API}/pending-updates`, { credentials: 'include' }),
        fetch(`${API}/admin/group-churches`, { credentials: 'include' })
      ]);
      if (ovR.ok) setOverview(await ovR.json());
      if (axR.ok) setAuxiliares(await axR.json());
      if (psR.ok) setPessoas(await psR.json());
      if (pnR.ok) setPessoasPendentes(await pnR.json());
      if (rjR.ok) setPessoasRejeitadas(await rjR.json());
      if (evR.ok) setEventsStats(await evR.json());
      if (frR.ok) setFrequencyReport(await frR.json());
      if (arR.ok) setAuxiliarReport(await arR.json());
      if (lgR.ok) setAuditLogs(await lgR.json());
      if (stR.ok) setPessoasStats(await stR.json());
      if (esR.ok) setEvents(await esR.json());
      if (eerR.ok) setEventsEngagement(await eerR.json());
      if (pgR.ok) setPerguntas(await pgR.json());
      if (vsR.ok) setVisitas(await vsR.json());
      if (adR.ok) setAdmins(await adR.json());
      if (teR.ok) setTiposEvento(await teR.json());
      if (puR.ok) setPendingUpdates(await puR.json());
      if (gcR.ok) setGroupChurchesData(await gcR.json());
      setGroupChurchesLoaded(true);
      fetchNotifications();
      // Fetch service functions for tipo_evento config
      fetch(`${API}/service-functions`, { credentials: 'include' }).then(r => r.ok ? r.json() : []).then(setServiceFunctions).catch(() => {});
      // Check recurring events
      fetch(`${API}/events/check-recorrencia`, { method: 'POST', credentials: 'include' }).catch(() => {});
      // Check calendar status
      fetch(`${API}/calendar/status`, { credentials: 'include' }).then(r => r.ok ? r.json() : null).then(d => { if (d) setCalendarStatus(d); }).catch(() => {});
    } catch { navigate('/'); }
  };

  const fetchPessoasData = async () => {
    setPessoasLoading(true);
    try {
      const [psR, pnR, rjR, stR, puR, axR] = await Promise.all([
        fetch(`${API}/pessoas?status=aprovado`, { credentials: 'include' }),
        fetch(`${API}/pessoas?status=pendente`, { credentials: 'include' }),
        fetch(`${API}/pessoas?status=rejeitado`, { credentials: 'include' }),
        fetch(`${API}/pessoas/stats`, { credentials: 'include' }),
        fetch(`${API}/pending-updates`, { credentials: 'include' }),
        fetch(`${API}/auxiliares/stats`, { credentials: 'include' }),
      ]);
      if (psR.ok) setPessoas(await psR.json());
      if (pnR.ok) setPessoasPendentes(await pnR.json());
      if (rjR.ok) setPessoasRejeitadas(await rjR.json());
      if (stR.ok) setPessoasStats(await stR.json());
      if (puR.ok) setPendingUpdates(await puR.json());
      if (axR.ok) setAuxiliares(await axR.json());
    } catch {
      toast.error('Erro ao carregar pessoas.');
    } finally {
      setPessoasLoading(false);
    }
  };

  const handleLogout = async () => {
    try { await fetch(`${API}/auth/logout`, { method: 'POST', credentials: 'include' }); } catch {}
    navigate('/');
  };

  const copyPublicLink = () => {
    const s = slugCadastro || churchSlug;
    const link = s ? `${window.location.origin}/pessoas/${s}` : `${window.location.origin}/pessoas`;
    navigator.clipboard.writeText(link);
    toast.success('Link de cadastro copiado!');
  };

  const copyPerguntasLink = () => {
    const s = slugPerguntas || churchSlug;
    const link = s ? `${window.location.origin}/perguntas/${s}` : `${window.location.origin}/perguntas`;
    navigator.clipboard.writeText(link);
    toast.success('Link de perguntas copiado!');
  };

  const openSlugEditor = (type) => {
    if (type === 'perguntas') setSlugForm(slugPerguntas || churchSlug || '');
    else if (type === 'visitas') setSlugForm(slugVisitas || '');
    else if (type === 'atualizar') setSlugForm(slugAtualizar || '');
    else if (type === 'agenda') setSlugForm(slugAgenda || '');
    else setSlugForm(slugCadastro || churchSlug || '');
    setSlugDialog(type);
  };

  const generateRandomSlug = () => {
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const random = Array.from({ length: 8 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    setSlugForm(random);
  };

  const saveSlug = async () => {
    const cleaned = slugForm.trim().toLowerCase().replace(/[^a-z0-9-]/g, '');
    if (!cleaned) { toast.error('URL invalida'); return; }
    try {
      const r = await fetch(`${API}/church/slug`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify({ slug: cleaned, type: slugDialog }) });
      if (!r.ok) { const e = await r.json(); throw new Error(e.detail || 'Erro'); }
      if (slugDialog === 'perguntas') setSlugPerguntas(cleaned);
      else if (slugDialog === 'visitas') setSlugVisitas(cleaned);
      else if (slugDialog === 'atualizar') setSlugAtualizar(cleaned);
      else if (slugDialog === 'agenda') setSlugAgenda(cleaned);
      else setSlugCadastro(cleaned);
      toast.success('URL atualizada!');
      setSlugDialog(null);
    } catch (err) { toast.error(err.message); }
  };

  const handleApprovePessoa = async (id) => {
    try { const r = await fetch(`${API}/pessoas/${id}/approve`, { method: 'POST', credentials: 'include' }); if (!r.ok) throw new Error(); toast.success('Aprovado!'); fetchAll(); } catch { toast.error('Erro ao aprovar'); }
  };

  const handleRejectPessoa = async (id) => {
    try { const r = await fetch(`${API}/pessoas/${id}/reject`, { method: 'POST', credentials: 'include' }); if (!r.ok) throw new Error(); toast.success('Rejeitado!'); fetchAll(); } catch { toast.error('Erro ao rejeitar'); }
  };

  const handleApproveUpdate = async (updateId) => {
    try { const r = await fetch(`${API}/pending-updates/${updateId}/approve`, { method: 'POST', credentials: 'include' }); if (!r.ok) throw new Error(); toast.success('Atualização aprovada!'); fetchAll(); } catch { toast.error('Erro ao aprovar atualização'); }
  };
  const handleRejectUpdate = async (updateId) => {
    try { const r = await fetch(`${API}/pending-updates/${updateId}/reject`, { method: 'POST', credentials: 'include' }); if (!r.ok) throw new Error(); toast.success('Atualização rejeitada!'); fetchAll(); } catch { toast.error('Erro ao rejeitar atualização'); }
  };

  const confirmDelete = (type, id, name, extra = {}) => { setItemToDelete({ type, id, name, ...extra }); setCancelRecurrence(true); setDeleteConfirmDialog(true); };
  const handleConfirmDelete = async () => {
    if (!itemToDelete) return;
    const ep = { auxiliar: `auxiliares/${itemToDelete.id}`, pessoa: `pessoas/${itemToDelete.id}`, evento: `events/${itemToDelete.id}`, motivo: `motivos-inativacao/${itemToDelete.id}`, tipo_evento: `tipos-evento/${itemToDelete.id}`, admin: `admins/${itemToDelete.id}` };
    try {
      // If cancelling recurrence, add date to excluded list
      if (itemToDelete.type === 'evento' && cancelRecurrence && itemToDelete.eventDate && itemToDelete.tipoEventoId) {
        await fetch(`${API}/tipos-evento/${itemToDelete.tipoEventoId}/exclude-date`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
          body: JSON.stringify({ date: itemToDelete.eventDate }),
        });
      }
      const r = await fetch(`${API}/${ep[itemToDelete.type]}`, { method: 'DELETE', credentials: 'include' });
      if (!r.ok) throw new Error();
      toast.success('Excluído!'); fetchAll();
    } catch { toast.error('Erro ao excluir'); }
    setDeleteConfirmDialog(false); setItemToDelete(null);
  };

  const openSettings = () => {
    setSettingsForm({ app_name: effectiveSettings.app_name, subtitle: effectiveSettings.subtitle, terms_of_use: effectiveSettings.terms_of_use, addons: effectiveSettings.addons || {}, engajamento_display: effectiveSettings.engajamento_display || 'niveis' });
    setSettingsDialog(true);
  };

  const topNavItems = [
  ];

  const showGroupChurchesTab = (groupChurchesData.groups || []).length > 0;

  const ebiNavItems = [
    { key: 'ebi-dashboard', label: 'EBI', icon: <BookOpenText className="w-3.5 h-3.5" /> },
  ];

  const engagementNavItems = [
    { key: 'dashboard', label: 'Dashboard', icon: <BarChart3 className="w-3.5 h-3.5" /> },
    { key: 'events', label: 'Eventos', icon: <Calendar className="w-3.5 h-3.5" /> },
    { key: 'pessoas', label: 'Pessoas', icon: <Users className="w-3.5 h-3.5" />, badge: (pessoasPendentes.length + pendingUpdates.length) > 0 ? pessoasPendentes.length + pendingUpdates.length : null },
    { key: 'attendance', label: 'Presença', icon: <CheckCircle2 className="w-3.5 h-3.5" /> },
    ...(activeAddons?.perguntas ? [{ key: 'perguntas', label: 'Perguntas', icon: <MessageSquare className="w-3.5 h-3.5" /> }] : []),
    ...(activeAddons?.visitas ? [{ key: 'visitas', label: 'Solicitação de Visita', icon: <Home className="w-3.5 h-3.5" /> }] : []),
  ];

  const managementNavItems = [
    ...(activeAddons?.votacoes ? [{ key: 'votacoes', label: 'Votações', icon: <Vote className="w-3.5 h-3.5" /> }] : []),
    ...(activeAddons?.reunioes ? [{ key: 'reunioes', label: 'Reuniões', icon: <BookOpen className="w-3.5 h-3.5" /> }] : []),
    ...(activeAddons?.whatsapp ? [{ key: 'whatsapp', label: 'WhatsApp', icon: <MessageSquare className="w-3.5 h-3.5" /> }] : []),
    ...(activeAddons?.cestas_basicas ? [{ key: 'cestas_basicas', label: 'Montagens', icon: <Package className="w-3.5 h-3.5" /> }] : []),
    ...(activeAddons?.batismos ? [{ key: 'batismos', label: 'Batismos', icon: <Droplets className="w-3.5 h-3.5" /> }] : []),
  ];

  const selectSection = (sectionKey) => {
    if (sectionKey === 'ebi-links') {
      setEbiLinksDialog(true);
      return;
    }
    if (sectionKey === 'ebi-ai') {
      setEbiAiDialog(true);
      return;
    }
    setActiveSection(sectionKey);
  };

  const sendAdminTempPassword = async (admin) => {
    setSendingAdminPasswordId(admin.user_id);
    try {
      const r = await fetch(`${API}/admins/${admin.user_id}/send-temp-password`, { method: 'POST', credentials: 'include' });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.detail || 'Erro ao enviar senha temporária');
      toast.success('Senha temporária enviada por SMS');
      setAdminTempPasswordTarget(null);
      fetchAll();
    } catch (err) { toast.error(err.message); } finally { setSendingAdminPasswordId(null); }
  };

  const handleSaveSettings = async () => {
    setSavingSettings(true);
    try {
      const r = await fetch(`${API}/settings`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
        body: JSON.stringify(settingsForm)
      });
      if (!r.ok) { const e = await r.json(); throw new Error(e.detail || 'Erro'); }
      toast.success('Configurações salvas!');
      setSettingsDialog(false);
      refreshSettings();
      fetchAll();
    } catch (err) { toast.error(err.message); } finally { setSavingSettings(false); }
  };

  // Motivos de inativacao
  const fetchMotivos = async () => {
    try { const r = await fetch(`${API}/motivos-inativacao`, { credentials: 'include' }); if (r.ok) setMotivos(await r.json()); } catch {}
  };

  // WhatsApp Evolution functions
  const fetchEvoStatus = async () => {
    setEvoStatusLoading(true);
    try { const r = await fetch(`${API}/evo/instance/status`, { credentials: 'include' }); if (r.ok) setEvoStatus(await r.json()); } catch {}
    setEvoStatusLoading(false);
  };
  const evoState = evoStatus?.instance?.state || evoStatus?.state || 'not_created';
  const evoConnected = evoState === 'open';
  const evoInstanceReady = !!settingsForm.addons?.whatsapp && evoState !== 'not_created';

  const fetchEvoQR = async () => {
    setEvoQrLoading(true); setEvoQrModal(true); setEvoQrData(null);
    try { const r = await fetch(`${API}/evo/instance/qrcode`, { credentials: 'include' }); if (r.ok) { const d = await r.json(); setEvoQrData(d.base64 || d.qrcode || d); } else { const e = await r.json().catch(() => ({})); toast.error(e.detail || 'QR Code ainda não disponível'); } } catch { toast.error('Erro ao buscar QR Code'); }
    setEvoQrLoading(false);
  };

  const generateInstanceName = () => {
    const church = (settingsForm.app_name || 'igreja').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, '_');
    const usr = (user?.name || 'admin').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, '_');
    const uid = (user?.user_id || '').replace('usr_', '').slice(0, 8);
    return `${church}_${usr}_${uid}`;
  };

  const handleEvoToggle = async (checked) => {
    setEvoToggling(true);
    if (checked) {
      // Activate: create instance + enable addon + open QR
      try {
        toast.info('Aguarde, estamos habilitando o WhatsApp...');
        const instanceName = generateInstanceName();
        const r = await fetch(`${API}/evo/whatsapp/enable`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify({ instanceName }) });
        if (r.ok) {
          const data = await r.json();
          const newAddons = data.addons || { ...(settingsForm.addons || {}), whatsapp: true };
          setSettingsForm(prev => ({ ...prev, addons: newAddons }));
          toast.success('WhatsApp ativado!');
          const qrPayload = data.qr || data;
          if (qrPayload?.base64 || qrPayload?.qrcode) { setEvoQrData(qrPayload.base64 || qrPayload.qrcode); setEvoQrModal(true); } else fetchEvoQR();
          fetchEvoStatus();
          refreshSettings(); fetchAll();
        } else { const err = await r.json().catch(() => ({})); toast.error(err.detail || 'Erro ao criar instância'); }
      } catch { toast.error('Erro ao ativar WhatsApp'); }
    } else {
      // Deactivate: disconnect + delete instance + save addon
      try {
        const r = await fetch(`${API}/evo/whatsapp/disable`, { method: 'POST', credentials: 'include' });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.detail || 'Erro ao desativar WhatsApp');
        const newAddons = data.addons || { ...(settingsForm.addons || {}), whatsapp: false };
        setSettingsForm(prev => ({ ...prev, addons: newAddons }));
        refreshSettings(); fetchAll();
        setEvoStatus(null);
        setEvoQrData(null);
        setEvoQrModal(false);
        toast.success('WhatsApp desativado');
      } catch (err) { toast.error(err.message || 'Erro ao desativar WhatsApp'); }
    }
    setEvoToggling(false);
  };

  // Poll QR modal for connection
  useEffect(() => {
    if (!evoQrModal) return;
    const interval = setInterval(async () => {
      try {
        const r = await fetch(`${API}/evo/instance/status`, { credentials: 'include' });
        if (r.ok) { const d = await r.json(); if ((d?.instance?.state || d?.state) === 'open') { setEvoStatus(d); setEvoQrModal(false); toast.success('WhatsApp conectado!'); clearInterval(interval); } }
      } catch {}
    }, 3000);
    return () => clearInterval(interval);
  }, [evoQrModal]);

  // Fetch evo status on load if whatsapp addon is active
  useEffect(() => { if (settingsForm.addons?.whatsapp) fetchEvoStatus(); }, [settingsForm.addons?.whatsapp]);

  const handleSaveMotivo = async () => {
    if (!motivoForm.nome.trim()) { toast.error('Nome do motivo é obrigatório'); return; }
    try {
      const url = editingMotivo ? `${API}/motivos-inativacao/${editingMotivo.motivo_id}` : `${API}/motivos-inativacao`;
      const r = await fetch(url, { method: editingMotivo ? 'PUT' : 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify({ nome: motivoForm.nome.trim() }) });
      if (!r.ok) { const e = await r.json(); throw new Error(e.detail || 'Erro'); }
      toast.success(editingMotivo ? 'Motivo atualizado!' : 'Motivo criado!');
      setMotivoDialog(false); setEditingMotivo(null); setMotivoForm({ nome: '' }); fetchMotivos();
    } catch (err) { toast.error(err.message); }
  };

  const handleDeleteMotivo = async (motivoId) => {
    try {
      const r = await fetch(`${API}/motivos-inativacao/${motivoId}`, { method: 'DELETE', credentials: 'include' });
      if (!r.ok) throw new Error();
      toast.success('Motivo excluído!'); fetchMotivos();
    } catch { toast.error('Erro ao excluir motivo'); }
  };

  // Tipos de Evento CRUD
  const resetTipoEventoForm = () => { setTipoEventoForm({ nome: '', fechamento_valor: '', fechamento_unidade: 'horas', tem_presidencia: false, tem_participantes: false, tem_musicos: false, tem_recitativos: false, tem_ministerio: false, eh_material: false, disponivel_reuniao: false, permite_pessoa: false, permite_escala_servicos: false, escalas_servico_ids: [], recorrencia_ativa: false, recorrencia_inicio: '', recorrencia_dia_semana: '', recorrencia_horario: '', recorrencia_frequencia: 'semanal', recorrencia_antecedencia_valor: '', recorrencia_antecedencia_unidade: 'horas', notificar_whatsapp: false, notificacao_dias: [1, 2], notificacao_msg: '*CCBRJM*\n\nPaz de Deus! Passando para lembrar que temos evento {tempo}:\n\n📅 *{nome_evento}*\n🕐 {dia_semana}, {data} às {hora}\n\nContamos com sua presença! Deus te abençoe.' }); setEditingTipoEvento(null); };

  const handleSaveTipoEvento = async () => {
    if (!tipoEventoForm.nome.trim()) { toast.error('Nome do tipo de evento é obrigatório'); return; }
    if (tipoEventoForm.permite_escala_servicos && (!tipoEventoForm.escalas_servico_ids || tipoEventoForm.escalas_servico_ids.length === 0)) {
      toast.error('Selecione ao menos uma escala de serviço para associar a este tipo de evento');
      return;
    }
    setSavingTipoEvento(true);
    try {
      const payload = {
        nome: tipoEventoForm.nome.trim(),
        fechamento_valor: tipoEventoForm.fechamento_valor !== '' ? parseInt(tipoEventoForm.fechamento_valor) : null,
        fechamento_unidade: tipoEventoForm.fechamento_unidade,
        tem_presidencia: tipoEventoForm.tem_presidencia,
        tem_participantes: tipoEventoForm.tem_participantes,
        tem_musicos: tipoEventoForm.tem_musicos,
        tem_recitativos: tipoEventoForm.tem_recitativos,
        tem_ministerio: tipoEventoForm.tem_ministerio,
        eh_material: tipoEventoForm.eh_material,
        disponivel_reuniao: tipoEventoForm.disponivel_reuniao,
        permite_pessoa: tipoEventoForm.permite_pessoa,
        permite_escala_servicos: tipoEventoForm.permite_escala_servicos,
        escalas_servico_ids: tipoEventoForm.permite_escala_servicos ? tipoEventoForm.escalas_servico_ids : [],
        recorrencia_ativa: tipoEventoForm.recorrencia_ativa,
        recorrencia_inicio: tipoEventoForm.recorrencia_ativa ? tipoEventoForm.recorrencia_inicio : null,
        recorrencia_dia_semana: tipoEventoForm.recorrencia_ativa ? tipoEventoForm.recorrencia_dia_semana : null,
        recorrencia_horario: tipoEventoForm.recorrencia_ativa ? tipoEventoForm.recorrencia_horario : null,
        recorrencia_frequencia: tipoEventoForm.recorrencia_frequencia,
        recorrencia_antecedencia_valor: tipoEventoForm.recorrencia_ativa && tipoEventoForm.recorrencia_antecedencia_valor ? parseInt(tipoEventoForm.recorrencia_antecedencia_valor) : null,
        recorrencia_antecedencia_unidade: tipoEventoForm.recorrencia_ativa ? tipoEventoForm.recorrencia_antecedencia_unidade : 'horas',
        notificar_whatsapp: tipoEventoForm.notificar_whatsapp,
        notificacao_dias: tipoEventoForm.notificar_whatsapp ? tipoEventoForm.notificacao_dias : [],
        notificacao_msg: tipoEventoForm.notificar_whatsapp ? tipoEventoForm.notificacao_msg : null,
      };
      const url = editingTipoEvento ? `${API}/tipos-evento/${editingTipoEvento.tipo_evento_id}` : `${API}/tipos-evento`;
      const method = editingTipoEvento ? 'PUT' : 'POST';
      const r = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify(payload) });
      if (!r.ok) { const e = await r.json(); throw new Error(e.detail || 'Erro'); }
      toast.success(editingTipoEvento ? 'Tipo de evento atualizado!' : 'Tipo de evento criado!');
      resetTipoEventoForm();
      setTipoEventoDialog(false);
      fetchAll();
    } catch (err) { toast.error(err.message); } finally { setSavingTipoEvento(false); }
  };


  if (!user || !overview) {
    return (<div className="min-h-screen flex items-center justify-center bg-slate-50"><div className="text-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div><p className="mt-4 text-slate-600">Carregando...</p></div></div>);
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <TestBanner />
      {/* Impersonate Banner */}
      {isImpersonating && (
        <div className="bg-amber-500 text-white text-center py-2 px-4 text-sm font-medium sticky top-0 z-[60] flex items-center justify-center gap-3" data-testid="impersonate-banner">
          <span>Visualizando como: <strong>{user?.name}</strong> — Sessão temporária (30 min)</span>
          <button onClick={async () => {
            try {
              const origToken = localStorage.getItem('original_gestor_token') || localStorage.getItem('original_admin_token');
              await fetch(`${API}/auth/logout`, { method: 'POST', credentials: 'include' });
              if (origToken) {
                localStorage.removeItem('original_gestor_token');
                localStorage.removeItem('original_admin_token');
                window.location.href = `${API}/auth/impersonate?token=${origToken}&redirect=/admin`;
              } else {
                window.location.href = '/admin';
              }
            } catch { window.location.href = '/admin'; }
          }} className="px-3 py-1 bg-white/20 hover:bg-white/30 rounded text-xs font-semibold transition-colors" data-testid="end-impersonate-btn">
            Encerrar e voltar
          </button>
        </div>
      )}
      <AdminDashboardHeader
        settings={effectiveSettings}
        user={user}
        activeSection={activeSection}
        topNavItems={topNavItems}
        engagementNavItems={engagementNavItems}
        managementNavItems={managementNavItems}
        ebiNavItems={ebiNavItems}
        showGroupChurchesTab={showGroupChurchesTab}
        notifications={notifications}
        bellOpen={bellOpen}
        setBellOpen={setBellOpen}
        fetchNotifications={fetchNotifications}
        navigate={navigate}
        openSettings={openSettings}
        setSettingsTab={setSettingsTab}
        setSettingsDialog={setSettingsDialog}
        setOnboardingOpen={setOnboardingOpen}
        setAuditoriaDialog={setAuditoriaDialog}
        setChangelogDialog={setChangelogDialog}
        handleLogout={handleLogout}
        selectSection={selectSection}
      />
      {/* Notifications only via bell icon */}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {activeSection === 'dashboard' && <DashboardTab overview={overview} pessoas={pessoas} pessoasStats={pessoasStats} eventsEngagement={eventsEngagement} events={eventsStats} frequencyReport={frequencyReport} tiposEvento={tiposEvento} engajamentoDisplay={settings?.engajamento_display || 'niveis'} />}
        {activeSection === 'pessoas' && <PessoasTab pessoasStats={pessoasStats} pessoas={pessoas} auxiliares={auxiliares} loading={pessoasLoading} onRefresh={fetchPessoasData} onDelete={confirmDelete} motivos={motivos} fetchMotivos={fetchMotivos} pessoasPendentes={pessoasPendentes} pessoasRejeitadas={pessoasRejeitadas} onApprove={handleApprovePessoa} onReject={handleRejectPessoa} pendingEditPessoaId={pendingEditPessoaId} onClearPendingEdit={() => setPendingEditPessoaId(null)} pendingUpdates={pendingUpdates} onApproveUpdate={handleApproveUpdate} onRejectUpdate={handleRejectUpdate} engajamentoDisplay={settings?.engajamento_display || 'niveis'} />}
        {activeSection === 'igrejas-grupo' && <IgrejasGrupoTab data={groupChurchesData} />}
        {activeSection === 'events' && <EventosTab events={eventsStats} onRefresh={fetchAll} onDelete={confirmDelete} tiposEvento={tiposEvento} pessoas={pessoas} />}
        {activeSection === 'attendance' && <PresencaTab events={events} pessoas={pessoas} auxiliares={auxiliares} tiposEvento={tiposEvento} user={user} fetchNotifications={fetchNotifications} onEventUpdate={(updated) => { setEvents(prev => prev.map(e => e.event_id === updated.event_id ? updated : e)); fetchAll(); }} />}
        {activeAddons?.perguntas && activeSection === 'perguntas' && <PerguntasTab perguntas={perguntas} onRefresh={fetchAll} />}
        {activeAddons?.visitas && activeSection === 'visitas' && <VisitasTab visitas={visitas} onRefresh={fetchAll} tiposEvento={tiposEvento} pessoas={pessoas} />}
        {activeAddons?.votacoes && activeSection === 'votacoes' && <VotacoesTab />}
        {activeAddons?.reunioes && activeSection === 'reunioes' && <ReunioesTab votacoesEnabled={!!activeAddons?.votacoes} />}
        {activeAddons?.whatsapp && activeSection === 'whatsapp' && <WhatsAppTab />}
        {activeAddons?.cestas_basicas && activeSection === 'cestas_basicas' && <CestasBasicasTab />}
        {activeAddons?.batismos && activeSection === 'batismos' && <BatismosTab />}
        {activeSection === 'movimentos' && <MovimentosTab />}
        {settings?.addons?.ebi && activeSection.startsWith('ebi-') && <EbiTab activeTab={activeSection} aiEnabled={!!settings?.addons?.ebi_ai} />}
        <Dialog open={ebiLinksDialog} onOpenChange={setEbiLinksDialog}>
          <DialogContent className="max-w-2xl max-h-[86vh] overflow-y-auto p-0" data-testid="ebi-links-settings-modal">
            <div className="p-4 bg-white">
              <EbiTab activeTab="links" modalMode aiEnabled={!!settings?.addons?.ebi_ai} />
            </div>
          </DialogContent>
        </Dialog>
        {settings?.addons?.ebi_ai && <Dialog open={ebiAiDialog} onOpenChange={setEbiAiDialog}>
          <DialogContent className="max-w-3xl h-[84vh] max-h-[90vh] overflow-hidden p-0 sm:p-0" data-testid="ebi-ai-settings-modal">
            <div className="h-full min-h-0 flex flex-col bg-white">
            <div className="px-6 pt-5 pb-4 border-b border-slate-100 bg-white">
              <DialogHeader>
                <DialogTitle className="flex items-center gap-2 text-slate-950"><span className="w-9 h-9 rounded-lg bg-blue-50 text-blue-700 flex items-center justify-center"><Sparkles className="w-5 h-5" /></span>Análise com IA</DialogTitle>
                <DialogDescription>Configure o prompt e o nível de rigor usados na análise das histórias EBI.</DialogDescription>
              </DialogHeader>
            </div>
            <div className="flex-1 min-h-0 overflow-y-auto p-6 bg-slate-50/70">
              <EbiTab activeTab="ai" modalMode aiEnabled={!!settings?.addons?.ebi_ai} />
            </div>
            </div>
          </DialogContent>
        </Dialog>}
        {activeSection === 'reports' && <RelatoriosTab frequencyReport={frequencyReport} auxiliarReport={auxiliarReport} eventsEngagement={eventsEngagement} pessoas={pessoasStats} tiposEvento={tiposEvento} showEventosBtn={true} onEditPessoa={(pessoaId) => { setPendingEditPessoaId(pessoaId); }} engajamentoDisplay={settings?.engajamento_display || 'niveis'} />}
      </div>

      {/* IMPORT PREVIEW DIALOG */}
      <Dialog open={!!importPreview} onOpenChange={(v) => { if (!v) setImportPreview(null); }}>
        <DialogContent className="max-w-[95vw] w-full max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle>Pré-visualização - {importPreview?.label}</DialogTitle>
          </DialogHeader>
          {importPreview && (() => {
            const allFields = [...new Set(importPreview.data.flatMap(row => Object.keys(row)))].filter(f => f !== '_id');
            return (
            <div className="flex flex-col gap-4 flex-1 min-h-0">
              <div className="flex flex-wrap gap-3 text-sm">
                <span className="text-slate-500">{importPreview.data.length} registro(s)</span>
                {importPreview.toInsert > 0 && <Badge className="bg-green-100 text-green-700 border-green-200">{importPreview.toInsert} novo(s)</Badge>}
                {importPreview.toUpdate > 0 && <Badge className="bg-amber-100 text-amber-700 border-amber-200">{importPreview.toUpdate} a atualizar</Badge>}
              </div>
              <div className="flex-1 min-h-0 overflow-auto rounded-lg border border-slate-200">
                <table className="w-max min-w-full text-xs">
                  <thead className="bg-slate-50 sticky top-0 z-10">
                    <tr>
                      <th className="px-3 py-2 text-left font-semibold text-slate-600 border-b whitespace-nowrap sticky left-0 bg-slate-50 z-20">Status</th>
                      {allFields.map(f => (
                        <th key={f} className="px-3 py-2 text-left font-semibold text-slate-600 border-b whitespace-nowrap">{f}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    {importPreview.data.map((row, i) => {
                      const status = (importPreview.statuses || [])[i] || 'inserir';
                      return (
                        <tr key={i} className="hover:bg-slate-50">
                          <td className="px-3 py-2 sticky left-0 bg-white z-10">
                            {status === 'atualizar'
                              ? <Badge variant="outline" className="text-[10px] bg-amber-50 text-amber-700 border-amber-200 whitespace-nowrap">Atualizar</Badge>
                              : <Badge variant="outline" className="text-[10px] bg-green-50 text-green-700 border-green-200 whitespace-nowrap">Novo</Badge>}
                          </td>
                          {allFields.map(f => (
                            <td key={f} className="px-3 py-2 text-slate-700 max-w-[300px] truncate whitespace-nowrap">{typeof row[f] === 'object' ? JSON.stringify(row[f]) : String(row[f] ?? '')}</td>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="flex justify-end gap-3 pt-2 border-t border-slate-100">
                <Button variant="outline" onClick={() => setImportPreview(null)} data-testid="import-cancel-btn">Cancelar</Button>
                <Button className="bg-blue-600 hover:bg-blue-700" data-testid="import-confirm-btn"
                  onClick={async () => {
                    try {
                      const fd = new FormData(); fd.append('file', importPreview.file);
                      const res = await fetch(`${API}/backup/import/${importPreview.key}`, { method: 'POST', body: fd, credentials: 'include' });
                      const result = await res.json();
                      if (!res.ok) throw new Error(result.detail || 'Erro');
                      toast.success(result.message);
                      setImportPreview(null);
                      fetchAll();
                    } catch (err) { toast.error(err.message || 'Erro ao importar'); }
                  }}>
                  Continuar
                </Button>
              </div>
            </div>
            );
          })()}
        </DialogContent>
      </Dialog>

      {/* DELETE DIALOG */}
      <Dialog open={deleteConfirmDialog} onOpenChange={setDeleteConfirmDialog}>
        <DialogContent>
          <DialogHeader><DialogTitle>Confirmar Exclusão</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <p>Tem certeza que deseja excluir <strong>{itemToDelete?.name}</strong>?</p>
            <p className="text-sm text-slate-500">Esta ação não pode ser desfeita.</p>
            {itemToDelete?.type === 'evento' && itemToDelete?.isRecorrente && (
              <label className="flex items-center gap-2 cursor-pointer bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 mt-2">
                <input type="checkbox" checked={cancelRecurrence} onChange={(e) => setCancelRecurrence(e.target.checked)} className="w-4 h-4 rounded border-slate-300 text-amber-600 focus:ring-amber-500" />
                <span className="text-sm text-slate-700">Cancelar recorrência desta data</span>
              </label>
            )}
            <div className="flex gap-3 justify-end">
              <Button variant="outline" onClick={() => { setDeleteConfirmDialog(false); setItemToDelete(null); }}>Cancelar</Button>
              <Button className="bg-red-600 hover:bg-red-700 text-white" onClick={handleConfirmDelete} data-testid="confirm-delete-btn">Excluir</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* SETTINGS DIALOG */}
      <Dialog open={settingsDialog} onOpenChange={(v) => { setSettingsDialog(v); if (!v) { setSettingsTab('geral'); } }}>
        <DialogContent className="max-w-4xl max-h-[85vh] p-0 sm:p-0 overflow-hidden">
          <div className="flex h-[70vh]">
            {/* Sidebar */}
            <div className="w-12 sm:w-56 bg-slate-50 border-r border-slate-200 p-2 sm:p-4 flex flex-col gap-1 flex-shrink-0 overflow-y-auto">
              <p className="hidden sm:block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 px-2">Configurações</p>
              <button onClick={() => setSettingsTab('geral')} className={`flex items-center justify-center sm:justify-start gap-2 px-2 sm:px-3 py-2 rounded-lg text-sm font-medium transition-colors text-left ${settingsTab === 'geral' ? 'bg-blue-600 text-white' : 'text-slate-700 hover:bg-slate-200'}`} data-testid="settings-tab-geral">
                <Settings className="w-4 h-4 flex-shrink-0" /><span className="hidden sm:inline">Geral</span>
              </button>
              <button onClick={() => setSettingsTab('admins')} className={`flex items-center justify-center sm:justify-start gap-2 px-2 sm:px-3 py-2 rounded-lg text-sm font-medium transition-colors text-left ${settingsTab === 'admins' ? 'bg-blue-600 text-white' : 'text-slate-700 hover:bg-slate-200'}`} data-testid="settings-tab-admins">
                <Shield className="w-4 h-4 flex-shrink-0" /><span className="hidden sm:inline">Administradores</span>
              </button>
              <button onClick={() => setSettingsTab('addons')} className={`flex items-center justify-center sm:justify-start gap-2 px-2 sm:px-3 py-2 rounded-lg text-sm font-medium transition-colors text-left ${settingsTab === 'addons' ? 'bg-blue-600 text-white' : 'text-slate-700 hover:bg-slate-200'}`} data-testid="settings-tab-addons">
                <Puzzle className="w-4 h-4 flex-shrink-0" /><span className="hidden sm:inline">Complementos</span>
              </button>
              {user?.role === 'gestor' && (
              <button onClick={() => setSettingsTab('backup')} className={`flex items-center justify-center sm:justify-start gap-2 px-2 sm:px-3 py-2 rounded-lg text-sm font-medium transition-colors text-left ${settingsTab === 'backup' ? 'bg-blue-600 text-white' : 'text-slate-700 hover:bg-slate-200'}`} data-testid="settings-tab-backup">
                <FileText className="w-4 h-4 flex-shrink-0" /><span className="hidden sm:inline">Backup</span>
              </button>
              )}
              <p className="hidden sm:block text-xs font-semibold text-slate-400 uppercase tracking-wider mt-4 mb-2 px-2">Apoio</p>
              <button onClick={() => setSettingsTab('tipos_evento')} className={`flex items-center justify-center sm:justify-start gap-2 px-2 sm:px-3 py-2 rounded-lg text-sm font-medium transition-colors text-left ${settingsTab === 'tipos_evento' ? 'bg-blue-600 text-white' : 'text-slate-700 hover:bg-slate-200'}`} data-testid="settings-tab-tipos-evento">
                <Tag className="w-4 h-4 flex-shrink-0" /><span className="hidden sm:inline">Tipos de Eventos</span>
              </button>
              <button onClick={() => { setSettingsTab('motivos'); fetchMotivos(); }} className={`flex items-center justify-center sm:justify-start gap-2 px-2 sm:px-3 py-2 rounded-lg text-sm font-medium transition-colors text-left ${settingsTab === 'motivos' ? 'bg-blue-600 text-white' : 'text-slate-700 hover:bg-slate-200'}`} data-testid="settings-tab-motivos">
                <Info className="w-4 h-4 flex-shrink-0" /><span className="hidden sm:inline">Motivos</span>
              </button>
              <button onClick={() => setSettingsTab('links')} className={`flex items-center justify-center sm:justify-start gap-2 px-2 sm:px-3 py-2 rounded-lg text-sm font-medium transition-colors text-left ${settingsTab === 'links' ? 'bg-blue-600 text-white' : 'text-slate-700 hover:bg-slate-200'}`} data-testid="settings-tab-links">
                <Link className="w-4 h-4 flex-shrink-0" /><span className="hidden sm:inline">Links</span>
              </button>
              {settings?.addons?.escalas && (
              <>
              <p className="hidden sm:block text-xs font-semibold text-slate-400 uppercase tracking-wider mt-4 mb-2 px-2">Escalas</p>
              <button onClick={() => setSettingsTab('escalas_recitativos')} className={`flex items-center justify-center sm:justify-start gap-2 px-2 sm:px-3 py-2 rounded-lg text-sm font-medium transition-colors text-left ${settingsTab === 'escalas_recitativos' ? 'bg-blue-600 text-white' : 'text-slate-700 hover:bg-slate-200'}`} data-testid="settings-tab-escalas-recitativos">
                <BookOpen className="w-4 h-4 flex-shrink-0" /><span className="hidden sm:inline">Recitativos</span>
              </button>
              <button onClick={() => setSettingsTab('escalas_outros')} className={`flex items-center justify-center sm:justify-start gap-2 px-2 sm:px-3 py-2 rounded-lg text-sm font-medium transition-colors text-left ${settingsTab === 'escalas_outros' ? 'bg-blue-600 text-white' : 'text-slate-700 hover:bg-slate-200'}`} data-testid="settings-tab-escalas-outros">
                <ClipboardList className="w-4 h-4 flex-shrink-0" /><span className="hidden sm:inline">Outros Serviços</span>
              </button>
              <button onClick={() => setSettingsTab('escalas_revezamentos')} className={`flex items-center justify-center sm:justify-start gap-2 px-2 sm:px-3 py-2 rounded-lg text-sm font-medium transition-colors text-left ${settingsTab === 'escalas_revezamentos' ? 'bg-blue-600 text-white' : 'text-slate-700 hover:bg-slate-200'}`} data-testid="settings-tab-escalas-revezamentos">
                <RefreshCw className="w-4 h-4 flex-shrink-0" /><span className="hidden sm:inline">Revezamentos</span>
              </button>
              </>
              )}
            </div>
            {/* Content */}
            <div className="flex-1 overflow-y-auto p-4 sm:p-6 pt-8 sm:pt-10">
              {settingsTab === 'geral' && (
                <div className="space-y-5">
                  <h3 className="text-lg font-semibold text-slate-900" style={{ fontFamily: 'Work Sans, sans-serif' }}>Geral</h3>
                  <div>
                    <Label>Nome da Aplicação</Label>
                    <Input value={settingsForm.app_name} data-testid="settings-app-name" disabled className="bg-slate-50" />
                    <p className="text-xs text-slate-500 mt-1">Aparece no título do navegador, login e cabeçalhos.</p>
                  </div>
                  <div>
                    <Label>Subtítulo</Label>
                    <Input value={settingsForm.subtitle} onChange={(e) => setSettingsForm({ ...settingsForm, subtitle: e.target.value })} data-testid="settings-subtitle" />
                  </div>
                  <div>
                    <Label>Exibição de Engajamento</Label>
                    <Select value={settingsForm.engajamento_display || 'niveis'} onValueChange={(v) => setSettingsForm({ ...settingsForm, engajamento_display: v })}>
                      <SelectTrigger className="mt-1" data-testid="settings-engajamento-display"><SelectValue /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="niveis">Níveis de Engajamento (Baixo / Médio / Alto)</SelectItem>
                        <SelectItem value="percentual">Percentual (%)</SelectItem>
                      </SelectContent>
                    </Select>
                    <p className="text-xs text-slate-500 mt-1">Define como o engajamento é exibido para auxiliares e administradores.</p>
                  </div>
                  <Button onClick={handleSaveSettings} className="w-full bg-blue-600 hover:bg-blue-700" disabled={savingSettings} data-testid="settings-save-btn">
                    {savingSettings ? 'Salvando...' : 'Salvar Configurações'}
                  </Button>
                </div>
              )}
              {settingsTab === 'motivos' && (
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-slate-900 flex items-center gap-1.5" style={{ fontFamily: 'Work Sans, sans-serif' }}>Motivos de Inativação
                      <button onClick={() => setShowMotivosInfo(true)} className="text-slate-400 hover:text-slate-600 transition-colors" data-testid="motivos-info-btn"><HelpCircle className="w-4 h-4" /></button>
                    </h3>
                    <Button size="sm" onClick={() => { setEditingMotivo(null); setMotivoForm({ nome: '' }); setMotivoDialog(true); }} className="bg-blue-600 hover:bg-blue-700" data-testid="add-motivo-btn"><Plus className="w-4 h-4 mr-1" />Novo Motivo</Button>
                  </div>
                  <p className="text-sm text-slate-500">Motivos possíveis para inativar uma pessoa.</p>
                  <div data-testid="motivos-list">
                    {motivos.length === 0 ? (
                      <div className="text-center py-8 text-slate-400"><Info className="w-10 h-10 mx-auto mb-2 opacity-50" /><p className="text-sm">Nenhum motivo cadastrado</p></div>
                    ) : (
                      <div className="rounded-lg border border-slate-200 overflow-hidden">
                        <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider px-4 pt-3 pb-1">Motivos</p>
                        <div className="divide-y divide-slate-100">
                          {motivos.map(m => (
                            <div key={m.motivo_id} className="px-4 py-3 hover:bg-slate-50 transition-colors" data-testid={`motivo-${m.motivo_id}`}>
                              <div className="flex items-center justify-between">
                                <p className="font-medium text-sm text-slate-900">{m.nome}</p>
                                <div className="flex gap-1">
                                  <Button variant="ghost" size="sm" onClick={() => { setEditingMotivo(m); setMotivoForm({ nome: m.nome }); setMotivoDialog(true); }} className="text-blue-600 hover:bg-blue-50" data-testid={`edit-motivo-${m.motivo_id}`}><Edit className="w-4 h-4" /></Button>
                                  <Button variant="ghost" size="sm" onClick={() => handleDeleteMotivo(m.motivo_id)} className="text-red-600 hover:bg-red-50" data-testid={`delete-motivo-${m.motivo_id}`}><Trash2 className="w-4 h-4" /></Button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {settingsTab === 'links' && (
                <LinksSettingsTab refreshSettings={refreshSettings} openSlugEditor={(type) => openSlugEditor(type || 'cadastro')} />
              )}
              {settingsTab === 'escalas_recitativos' && settings?.addons?.escalas && (
                <EscalasSettingsTab filterType="recitativo" />
              )}
              {settingsTab === 'escalas_outros' && settings?.addons?.escalas && (
                <EscalasSettingsTab filterType="outros" />
              )}
              {settingsTab === 'escalas_revezamentos' && settings?.addons?.escalas && (
                <EscalasSettingsTab filterType="revezamentos" />
              )}
              {settingsTab === 'backup' && (
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900" style={{ fontFamily: 'Work Sans, sans-serif' }}>Backup</h3>
                    <p className="text-sm text-slate-500">Exporte ou importe dados do sistema. A estrutura do arquivo é validada antes da importação.</p>
                  </div>
                  <div className="rounded-lg border border-slate-200 overflow-hidden">
                    {[
                      { key: 'pessoas', label: 'Pessoas', icon: <Users className="w-4 h-4 text-blue-600" /> },
                      { key: 'eventos', label: 'Eventos', icon: <Calendar className="w-4 h-4 text-purple-600" /> },
                      { key: 'tipos_evento', label: 'Tipos de Evento', icon: <Tag className="w-4 h-4 text-orange-600" /> },
                      { key: 'reunioes', label: 'Reuniões', icon: <Users className="w-4 h-4 text-violet-600" /> },
                      { key: 'reuniao_pautas', label: 'Pautas', icon: <FileText className="w-4 h-4 text-teal-600" /> },
                      { key: 'reuniao_tarefas', label: 'Tarefas', icon: <CheckCircle2 className="w-4 h-4 text-green-600" /> },
                      { key: 'votacoes', label: 'Votações', icon: <Vote className="w-4 h-4 text-indigo-600" /> },
                      { key: 'motivos', label: 'Motivos', icon: <Info className="w-4 h-4 text-red-600" /> },
                      { key: 'links', label: 'Links', icon: <Link className="w-4 h-4 text-sky-600" /> },
                      { key: 'config_pagina_links', label: 'Config. Página Links', icon: <Settings className="w-4 h-4 text-slate-600" /> },
                    ].map(item => (
                      <div key={item.key} className="flex flex-col sm:flex-row sm:items-center justify-between px-4 py-3 border-b last:border-b-0 border-slate-100 hover:bg-slate-50 gap-2" data-testid={`backup-${item.key}`}>
                        <div className="flex items-center gap-3">
                          {item.icon}
                          <p className="font-medium text-sm text-slate-900">{item.label}</p>
                        </div>
                        <div className="flex gap-2 flex-wrap">
                          <Button variant="outline" size="sm" className="text-xs gap-1.5" data-testid={`export-${item.key}`}
                            onClick={async () => {
                              try {
                                const res = await fetch(`${API}/backup/export/${item.key}`, { credentials: 'include' });
                                if (!res.ok) throw new Error();
                                const data = await res.json();
                                const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
                                const url = URL.createObjectURL(blob);
                                const a = document.createElement('a'); a.href = url; a.download = `${item.key}_backup.json`; a.click();
                                URL.revokeObjectURL(url);
                                toast.success(`${item.label} exportado com sucesso!`);
                              } catch { toast.error('Erro ao exportar'); }
                            }}>
                            <FileText className="w-3.5 h-3.5" />Exportar
                          </Button>
                          <Button variant="outline" size="sm" className="text-xs gap-1.5" data-testid={`import-${item.key}`}
                            onClick={() => {
                              const input = document.createElement('input'); input.type = 'file'; input.accept = '.json,.txt';
                              input.onchange = async (e) => {
                                const file = e.target.files[0]; if (!file) return;
                                const fd = new FormData(); fd.append('file', file);
                                try {
                                  const valRes = await fetch(`${API}/backup/import/${item.key}/validate`, { method: 'POST', body: fd, credentials: 'include' });
                                  const valData = await valRes.json();
                                  if (!valRes.ok) { toast.error(valData.detail || 'Erro na validação'); return; }
                                  if (valData.empty) { toast.info('O arquivo JSON está vazio. Nenhum registro encontrado para importar.'); return; }
                                  if (valData.invalid > 0) {
                                    toast.error(`Arquivo rejeitado: ${valData.invalid} de ${valData.total} registros inválidos. ${valData.errors.join('. ')}`);
                                    return;
                                  }
                                  const text = await file.text();
                                  const parsed = JSON.parse(text);
                                  const records = Array.isArray(parsed) ? parsed : (parsed.data || []);
                                  setImportPreview({ key: item.key, label: item.label, data: records, file, fields: valData.sample_fields, statuses: valData.statuses || [], toInsert: valData.to_insert || 0, toUpdate: valData.to_update || 0 });
                                } catch (err) { toast.error(err.message || 'Erro ao validar arquivo'); }
                              };
                              input.click();
                            }}>
                            <Plus className="w-3.5 h-3.5" />Importar
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {settingsTab === 'tipos_evento' && (
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-slate-900 flex items-center gap-1.5" style={{ fontFamily: 'Work Sans, sans-serif' }}>Tipos de Evento
                      <button onClick={() => setShowTiposInfo(true)} className="text-slate-400 hover:text-slate-600 transition-colors" data-testid="tipos-info-btn"><HelpCircle className="w-4 h-4" /></button>
                    </h3>
                    <Button size="sm" onClick={() => { resetTipoEventoForm(); setTipoEventoDialog(true); }} className="bg-blue-600 hover:bg-blue-700" data-testid="add-tipo-evento-btn"><Plus className="w-4 h-4 mr-1" />Novo Tipo</Button>
                  </div>
                  <p className="text-sm text-slate-500">Categorize seus eventos por tipo, definindo regras de fechamento e contagens.</p>
                  <div data-testid="tipos-evento-list">
                    {tiposEvento.length === 0 ? (
                      <div className="text-center py-8 text-slate-400"><Tag className="w-10 h-10 mx-auto mb-2 opacity-50" /><p className="text-sm">Nenhum tipo de evento cadastrado</p></div>
                    ) : (() => {
                      const espirituais = tiposEvento.filter(t => !t.eh_material).sort((a, b) => a.nome.localeCompare(b.nome));
                      const materiais = tiposEvento.filter(t => t.eh_material).sort((a, b) => a.nome.localeCompare(b.nome));
                      const renderItem = (t) => (
                        <div key={t.tipo_evento_id} className="px-4 py-3 border-b last:border-b-0 border-slate-100 hover:bg-slate-50 transition-colors" data-testid={`tipo-evento-${t.tipo_evento_id}`}>
                          <div className="flex items-center justify-between">
                            <div className="flex-1 min-w-0">
                              <p className="font-medium text-sm text-slate-900">{t.nome}</p>
                              <div className="flex flex-wrap gap-1.5 mt-1">
                                {t.fechamento_valor && <span className="text-xs text-slate-500 bg-slate-100 px-1.5 py-0.5 rounded">{t.fechamento_valor} {t.fechamento_unidade}</span>}
                                {t.tem_presidencia && <TooltipProvider><Tooltip><TooltipTrigger asChild><span className="inline-flex items-center justify-center w-6 h-6 rounded bg-blue-50"><Crown className="w-3.5 h-3.5 text-blue-600" /></span></TooltipTrigger><TooltipContent><p className="text-xs">Presidência</p></TooltipContent></Tooltip></TooltipProvider>}
                                {t.tem_participantes && <TooltipProvider><Tooltip><TooltipTrigger asChild><span className="inline-flex items-center justify-center w-6 h-6 rounded bg-cyan-50"><UsersRound className="w-3.5 h-3.5 text-cyan-600" /></span></TooltipTrigger><TooltipContent><p className="text-xs">Participantes</p></TooltipContent></Tooltip></TooltipProvider>}
                                {t.tem_musicos && <TooltipProvider><Tooltip><TooltipTrigger asChild><span className="inline-flex items-center justify-center w-6 h-6 rounded bg-green-50"><Music className="w-3.5 h-3.5 text-green-600" /></span></TooltipTrigger><TooltipContent><p className="text-xs">Músicos</p></TooltipContent></Tooltip></TooltipProvider>}
                                {t.tem_recitativos && <TooltipProvider><Tooltip><TooltipTrigger asChild><span className="inline-flex items-center justify-center w-6 h-6 rounded bg-purple-50"><ScrollText className="w-3.5 h-3.5 text-purple-600" /></span></TooltipTrigger><TooltipContent><p className="text-xs">Recitativos</p></TooltipContent></Tooltip></TooltipProvider>}
                                {t.tem_ministerio && <TooltipProvider><Tooltip><TooltipTrigger asChild><span className="inline-flex items-center justify-center w-6 h-6 rounded bg-orange-50"><Flame className="w-3.5 h-3.5 text-orange-600" /></span></TooltipTrigger><TooltipContent><p className="text-xs">Ministério</p></TooltipContent></Tooltip></TooltipProvider>}
                                {t.disponivel_reuniao && <TooltipProvider><Tooltip><TooltipTrigger asChild><span className="inline-flex items-center justify-center w-6 h-6 rounded bg-violet-50"><Handshake className="w-3.5 h-3.5 text-violet-600" /></span></TooltipTrigger><TooltipContent><p className="text-xs">Reuniões</p></TooltipContent></Tooltip></TooltipProvider>}
                                {t.permite_pessoa && <TooltipProvider><Tooltip><TooltipTrigger asChild><span className="inline-flex items-center justify-center w-6 h-6 rounded bg-indigo-50"><User className="w-3.5 h-3.5 text-indigo-600" /></span></TooltipTrigger><TooltipContent><p className="text-xs">Permite associar pessoa</p></TooltipContent></Tooltip></TooltipProvider>}
                                {t.permite_escala_servicos && <TooltipProvider><Tooltip><TooltipTrigger asChild><span className="inline-flex items-center justify-center w-6 h-6 rounded bg-emerald-50"><ClipboardList className="w-3.5 h-3.5 text-emerald-600" /></span></TooltipTrigger><TooltipContent><p className="text-xs">Escala de Serviço</p></TooltipContent></Tooltip></TooltipProvider>}
                                {t.recorrencia_ativa && <TooltipProvider><Tooltip><TooltipTrigger asChild><span className="inline-flex items-center justify-center w-6 h-6 rounded bg-teal-50"><Repeat className="w-3.5 h-3.5 text-teal-600" /></span></TooltipTrigger><TooltipContent><p className="text-xs">Recorrente</p></TooltipContent></Tooltip></TooltipProvider>}
                              </div>
                            </div>
                            <div className="flex gap-1 flex-shrink-0">
                              <Button variant="ghost" size="sm" onClick={() => { setEditingTipoEvento(t); setTipoEventoForm({ nome: t.nome, fechamento_valor: t.fechamento_valor ?? '', fechamento_unidade: t.fechamento_unidade || 'horas', tem_presidencia: t.tem_presidencia || false, tem_participantes: t.tem_participantes || false, tem_musicos: t.tem_musicos || false, tem_recitativos: t.tem_recitativos || false, tem_ministerio: t.tem_ministerio || false, eh_material: t.eh_material || false, disponivel_reuniao: t.disponivel_reuniao || false, permite_pessoa: t.permite_pessoa || false, permite_escala_servicos: t.permite_escala_servicos || false, escalas_servico_ids: t.escalas_servico_ids || [], recorrencia_ativa: t.recorrencia_ativa || false, recorrencia_inicio: t.recorrencia_inicio || '', recorrencia_dia_semana: t.recorrencia_dia_semana ?? '', recorrencia_horario: t.recorrencia_horario || '', recorrencia_frequencia: t.recorrencia_frequencia || 'semanal', recorrencia_antecedencia_valor: t.recorrencia_antecedencia_valor ?? '', recorrencia_antecedencia_unidade: t.recorrencia_antecedencia_unidade || 'horas', notificar_whatsapp: t.notificar_whatsapp || false, notificacao_dias: t.notificacao_dias || [1, 2], notificacao_msg: t.notificacao_msg || '*CCBRJM*\n\nPaz de Deus! Passando para lembrar que temos evento {tempo}:\n\n📅 *{nome_evento}*\n🕐 {dia_semana}, {data} às {hora}\n\nContamos com sua presença! Deus te abençoe.' }); setTipoEventoDialog(true); }} className="text-blue-600 hover:bg-blue-50" data-testid={`edit-tipo-evento-${t.tipo_evento_id}`}><Edit className="w-4 h-4" /></Button>
                              <Button variant="ghost" size="sm" onClick={() => confirmDelete('tipo_evento', t.tipo_evento_id, t.nome)} className="text-red-600 hover:bg-red-50" data-testid={`delete-tipo-evento-${t.tipo_evento_id}`}><Trash2 className="w-4 h-4" /></Button>
                            </div>
                          </div>
                        </div>
                      );
                      return (
                        <div className="space-y-6">
                          {espirituais.length > 0 && (
                            <div className="rounded-lg border border-slate-200 overflow-hidden">
                              <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider px-4 pt-3 pb-1">Espiritual</p>
                              <div className="divide-y divide-slate-100">{espirituais.map(renderItem)}</div>
                            </div>
                          )}
                          {materiais.length > 0 && (
                            <div className="rounded-lg border border-slate-200 overflow-hidden mt-6">
                              <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider px-4 pt-3 pb-1">Material</p>
                              <div className="divide-y divide-slate-100">{materiais.map(renderItem)}</div>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                </div>
              )}
              {settingsTab === 'addons' && (
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-slate-900" style={{ fontFamily: 'Work Sans, sans-serif' }}>Complementos</h3>
                  <p className="text-sm text-slate-500">Ative ou desative complementos do sistema.</p>
                  <div data-testid="addons-list">
                    <div className="flex items-center justify-between px-4 py-4 border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors mt-3" data-testid="addon-escalas">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{backgroundColor:'#2662eb'}}><ClipboardList className="w-5 h-5 text-white" /></div>
                        <div>
                          <p className="font-medium text-sm text-slate-900">Escalas de Serviço</p>
                          <p className="text-xs text-slate-500">Habilita o revezamento automático de auxiliares nos eventos.</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        {settingsForm.addons?.escalas && <TooltipProvider><Tooltip><TooltipTrigger asChild><span className="inline-flex items-center justify-center h-8 w-8 text-slate-400 cursor-default"><Info className="w-4 h-4" /></span></TooltipTrigger><TooltipContent><p className="text-xs">Configure as funções em Configurações &gt; Escalas de Serviço. Ative a flag nos Tipos de Evento desejados.</p></TooltipContent></Tooltip></TooltipProvider>}
                        <Switch
                          checked={!!settingsForm.addons?.escalas}
                          onCheckedChange={async (checked) => {
                            const newAddons = { ...(settingsForm.addons || {}), escalas: checked };
                            setSettingsForm({ ...settingsForm, addons: newAddons });
                            try {
                              const r = await fetch(`${API}/settings`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify({ addons: newAddons }) });
                              if (r.ok) { refreshSettings(); fetchAll(); toast.success(checked ? 'Escalas de Serviço ativado' : 'Escalas de Serviço desativado'); }
                            } catch {}
                          }}
                          data-testid="toggle-addon-escalas"
                        />
                      </div>
                    </div>
                    <div className="flex items-center justify-between px-4 py-4 border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors mt-3" data-testid="addon-whatsapp">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 bg-green-600"><MessageSquare className="w-5 h-5 text-white" /></div>
                        <div>
                          <p className="font-medium text-sm text-slate-900 flex items-center gap-2">WhatsApp{evoConnected && <Badge className="text-[10px] bg-green-100 text-green-700 font-medium">conectado</Badge>}</p>
                          <p className="text-xs text-slate-500">Ativa campanhas e notificações via Evolution API.</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        {evoInstanceReady && !evoConnected && (
                          <TooltipProvider><Tooltip><TooltipTrigger asChild>
                            <Button variant="ghost" size="icon" className="h-8 w-8 text-green-600 hover:bg-green-50" onClick={fetchEvoQR} disabled={evoQrLoading} data-testid="whatsapp-qr-button" title="Conectar WhatsApp">
                              {evoQrLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <QrCode className="w-4 h-4" />}
                            </Button>
                          </TooltipTrigger><TooltipContent><p className="text-xs">Abrir QR Code para conectar</p></TooltipContent></Tooltip></TooltipProvider>
                        )}
                        {evoToggling ? <div className="h-9 w-12 inline-flex items-center justify-center" data-testid="toggle-addon-whatsapp-loading"><Loader2 className="w-5 h-5 animate-spin text-green-600" /></div> : <Switch
                          checked={!!settingsForm.addons?.whatsapp}
                          onCheckedChange={(checked) => {
                            if (!checked && settingsForm.addons?.whatsapp) {
                              setEvoDeactivateDialog(true);
                              return;
                            }
                            handleEvoToggle(checked);
                          }}
                          data-testid="toggle-addon-whatsapp"
                        />}
                      </div>
                    </div>
                    <div className="flex items-center justify-between px-4 py-4 border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors mt-3" data-testid="addon-calendar">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{backgroundColor:'#2662eb'}}><Calendar className="w-5 h-5 text-white" /></div>
                        <div>
                          <p className="font-medium text-sm text-slate-900 flex items-center gap-2">Habilitar Google Calendar{calendarStatus.connected && calendarStatus.synced_count > 0 && <Badge className="text-[10px] bg-green-100 text-green-700 font-medium">{calendarStatus.synced_count} sincronizados</Badge>}</p>
                          <p className="text-xs text-slate-500">Ao ativar, sincronize os aniversariantes e habilite a Agenda Pública no Google Calendar.</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        {!calendarStatus.connected ? (
                          <TooltipProvider><Tooltip><TooltipTrigger asChild>
                            <Button variant="ghost" size="icon" className="h-8 w-8 text-[#2662eb] hover:bg-blue-50" data-testid="calendar-connect-btn"
                              onClick={async () => {
                                try {
                                  const r = await fetch(`${API}/calendar/authorize`, { credentials: 'include' });
                                  if (r.ok) { const data = await r.json(); window.location.href = data.authorization_url; }
                                  else toast.error('Erro ao iniciar autorização');
                                } catch { toast.error('Erro ao conectar'); }
                              }}>
                              <LogIn className="w-4 h-4" />
                            </Button>
                          </TooltipTrigger><TooltipContent><p className="text-xs">Conectar ao Google Calendar</p></TooltipContent></Tooltip></TooltipProvider>
                        ) : (
                          <div className="flex items-center gap-0.5">
                            <TooltipProvider><Tooltip><TooltipTrigger asChild>
                              <Button variant="ghost" size="icon" className="h-8 w-8 text-[#2662eb] hover:bg-blue-50" data-testid="calendar-sync-btn" disabled={calendarLoading}
                                onClick={async () => {
                                  setCalendarLoading(true);
                                  try {
                                    const r = await fetch(`${API}/calendar/sync`, { method: 'POST', credentials: 'include' });
                                    if (r.ok) {
                                      const data = await r.json();
                                      toast.success(`${data.created} criados, ${data.updated} atualizados${data.skipped ? `, ${data.skipped} sem data` : ''}`);
                                      fetch(`${API}/calendar/status`, { credentials: 'include' }).then(r => r.ok ? r.json() : null).then(d => { if (d) setCalendarStatus(d); }).catch(() => {});
                                    } else { const e = await r.json().catch(() => ({})); toast.error(e.detail || 'Erro ao sincronizar'); }
                                  } catch { toast.error('Erro ao sincronizar'); }
                                  finally { setCalendarLoading(false); }
                                }}>
                                {calendarLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />}
                              </Button>
                            </TooltipTrigger><TooltipContent><p className="text-xs">Sincronizar aniversários</p></TooltipContent></Tooltip></TooltipProvider>
                            <TooltipProvider><Tooltip><TooltipTrigger asChild>
                              <Button variant="ghost" size="icon" className="h-8 w-8 text-red-400 hover:bg-red-50 hover:text-red-600" data-testid="calendar-disconnect-btn"
                                onClick={() => setCalendarDisconnectDialog(true)}>
                                <X className="w-4 h-4" />
                              </Button>
                            </TooltipTrigger><TooltipContent><p className="text-xs">Desconectar</p></TooltipContent></Tooltip></TooltipProvider>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {settingsTab === 'admins' && (
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-slate-900" style={{ fontFamily: 'Work Sans, sans-serif' }}>Administradores</h3>
                    <Button size="sm" onClick={() => { setEditingAdmin(null); setAdminForm({ name: '', email: '', phone: '' }); setAdminDialog(true); }} className="bg-blue-600 hover:bg-blue-700" data-testid="add-admin-btn"><Plus className="w-4 h-4 mr-1" />Novo Admin</Button>
                  </div>
                  <p className="text-sm text-slate-500">Usuarios com acesso administrativo ao sistema.</p>
                  <div data-testid="admins-list">
                    {admins.length === 0 ? (
                      <div className="text-center py-8 text-slate-400">
                        <Shield className="w-10 h-10 mx-auto mb-2 opacity-50" />
                        <p className="text-sm">Nenhum administrador cadastrado</p>
                      </div>
                    ) : (
                      <div className="rounded-lg border border-slate-200 overflow-hidden">
                        <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider px-4 pt-3 pb-1">Administradores</p>
                        <div className="divide-y divide-slate-100">
                          {admins.map(a => (
                            <div key={a.user_id} className="px-4 py-3 hover:bg-slate-50 transition-colors" data-testid={`admin-${a.user_id}`}>
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                  <div className="w-9 h-9 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center text-white font-bold text-sm">{a.name.charAt(0)}</div>
                                  <div>
                                    <p className="font-semibold text-sm text-slate-900">{a.name}</p>
                                    <p className="text-xs text-slate-500">{a.email}</p>
                                    <p className="text-xs text-slate-400">{a.phone || a.whatsapp || 'sem celular'} · {a.must_change_password ? 'troca pendente' : a.has_password ? 'senha configurada' : 'sem senha'}</p>
                                  </div>
                                </div>
                                <div className="flex gap-0.5">
                                  <Button variant="ghost" size="icon" className="h-8 w-8 text-emerald-600 hover:bg-emerald-50" disabled={sendingAdminPasswordId === a.user_id} onClick={() => setAdminTempPasswordTarget(a)} data-testid={`send-admin-temp-password-${a.user_id}`} title="Enviar nova senha temporária por SMS">{sendingAdminPasswordId === a.user_id ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />}</Button>
                                  <Button variant="ghost" size="icon" className="h-8 w-8 text-blue-600 hover:bg-blue-50" onClick={() => { setEditingAdmin(a); setAdminForm({ name: a.name, email: a.email, phone: a.phone || a.whatsapp || '' }); setAdminDialog(true); }} data-testid={`edit-admin-${a.user_id}`}><Edit className="w-4 h-4" /></Button>
                                  <Button variant="ghost" size="icon" className="h-8 w-8 text-red-600 hover:bg-red-50" onClick={() => confirmDelete('admin', a.user_id, a.name || a.email)} data-testid={`delete-admin-${a.user_id}`}><Trash2 className="w-4 h-4" /></Button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={!!adminTempPasswordTarget} onOpenChange={(open) => !open && setAdminTempPasswordTarget(null)}>
        <DialogContent className="max-w-md" data-testid="admin-temp-password-confirm-dialog">
          <DialogHeader><DialogTitle>Enviar nova senha temporária?</DialogTitle></DialogHeader>
          <div className="space-y-3 text-sm text-slate-600">
            <p>Uma nova senha temporária de 6 dígitos será enviada por SMS para:</p>
            <div className="rounded-lg bg-slate-50 border border-slate-200 p-3" data-testid="admin-temp-password-target-info">
              <p className="font-semibold text-slate-900">{adminTempPasswordTarget?.name || adminTempPasswordTarget?.email}</p>
              <p className="text-slate-500">{adminTempPasswordTarget?.phone || adminTempPasswordTarget?.whatsapp || 'sem celular'}</p>
            </div>
            <p>Ao confirmar, sessões existentes desse acesso serão encerradas e a troca de senha será obrigatória no próximo login.</p>
          </div>
          <div className="flex justify-end gap-2 mt-2">
            <Button variant="outline" onClick={() => setAdminTempPasswordTarget(null)} data-testid="admin-temp-password-cancel">Cancelar</Button>
            <Button onClick={() => sendAdminTempPassword(adminTempPasswordTarget)} disabled={!adminTempPasswordTarget || sendingAdminPasswordId === adminTempPasswordTarget?.user_id} className="bg-emerald-600 hover:bg-emerald-700" data-testid="admin-temp-password-confirm">
              {sendingAdminPasswordId === adminTempPasswordTarget?.user_id ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <KeyRound className="w-4 h-4 mr-1.5" />}Enviar SMS
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* URL EDITOR DIALOG */}

      {/* ADMIN CREATE/EDIT DIALOG */}
      <Dialog open={adminDialog} onOpenChange={setAdminDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle>{editingAdmin ? 'Editar Administrador' : 'Novo Administrador'}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div><Label>Nome Completo *</Label><Input placeholder="Nome completo" value={adminForm.name} onChange={(e) => setAdminForm({ ...adminForm, name: e.target.value })} data-testid="admin-form-name" /></div>
            <div><Label>Email *</Label><Input type="email" placeholder="email@exemplo.com" value={adminForm.email} onChange={(e) => setAdminForm({ ...adminForm, email: e.target.value })} data-testid="admin-form-email" /><p className="text-xs text-slate-500 mt-1">Este e-mail será o login do administrador.</p></div>
            <div><Label>Celular *</Label><Input placeholder="(11) 99999-9999" value={adminForm.phone} onChange={(e) => setAdminForm({ ...adminForm, phone: e.target.value })} data-testid="admin-form-phone" /><p className="text-xs text-slate-500 mt-1">Use para envio da senha temporária por SMS.</p></div>
            <Button className="w-full bg-blue-600 hover:bg-blue-700" disabled={savingAdmin || !adminForm.name || !adminForm.email || !adminForm.phone || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(adminForm.email)} data-testid="admin-form-save" onClick={async () => {
              setSavingAdmin(true);
              try {
                const url = editingAdmin ? `${API}/admins/${editingAdmin.user_id}` : `${API}/admins`;
                const method = editingAdmin ? 'PUT' : 'POST';
                const r = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify(adminForm) });
                if (r.ok) { fetchAll(); setAdminDialog(false); toast.success(editingAdmin ? 'Administrador atualizado!' : 'Administrador criado!'); }
              } catch {} finally { setSavingAdmin(false); }
            }}>
              {savingAdmin ? 'Salvando...' : 'Salvar'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* URL EDITOR DIALOG */}
      <Dialog open={!!slugDialog} onOpenChange={(v) => { if (!v) setSlugDialog(null); }}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle>Editar URL</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Identificador da URL</Label>
              <div className="flex gap-2">
                <Input value={slugForm} onChange={(e) => setSlugForm(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))} data-testid="slug-input" className="flex-1" />
                <Button variant="outline" size="icon" onClick={generateRandomSlug} title="Gerar aleatoriamente" data-testid="slug-random-btn"><RefreshCw className="w-4 h-4" /></Button>
                <Button variant="outline" size="icon" onClick={() => { const prefix = slugDialog === 'perguntas' ? '/perguntas/' : slugDialog === 'visitas' ? '/visitas/' : slugDialog === 'atualizar' ? '/atualizar/' : slugDialog === 'agenda' ? '/agenda/' : '/pessoas/'; const url = `${window.location.origin}${prefix}${slugForm}`; navigator.clipboard.writeText(url); toast.success('Link copiado!'); }} title="Copiar link" data-testid="slug-copy-btn"><Copy className="w-4 h-4" /></Button>
              </div>
              <p className="text-xs text-slate-500 mt-2">{`${window.location.origin}${slugDialog === 'perguntas' ? '/perguntas/' : slugDialog === 'visitas' ? '/visitas/' : slugDialog === 'atualizar' ? '/atualizar/' : slugDialog === 'agenda' ? '/agenda/' : '/pessoas/'}${slugForm || '...'}`}</p>
            </div>
            <Button onClick={saveSlug} className="w-full bg-blue-600 hover:bg-blue-700" data-testid="slug-save-btn">Salvar</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* TERMS OF USE DIALOG */}
      <Dialog open={termsDialog} onOpenChange={setTermsDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle>Termo de Uso</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div>
              <Textarea value={settingsForm.terms_of_use} onChange={(e) => setSettingsForm({ ...settingsForm, terms_of_use: e.target.value })} rows={8} data-testid="settings-terms" />
              <p className="text-xs text-slate-500 mt-1">Exibido no formulário de cadastro público. Deixe vazio para não exibir.</p>
            </div>
            <Button onClick={async () => { try { const r = await fetch(`${API}/settings`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify({ terms_of_use: settingsForm.terms_of_use }) }); if (r.ok) { refreshSettings(); toast.success('Termo de uso salvo!'); setTermsDialog(false); } } catch {} }} className="w-full bg-blue-600 hover:bg-blue-700" data-testid="terms-save-btn">Salvar</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* MOTIVO CREATE/EDIT DIALOG */}
      <Dialog open={motivoDialog} onOpenChange={(v) => { setMotivoDialog(v); if (!v) { setEditingMotivo(null); setMotivoForm({ nome: '' }); } }}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle>{editingMotivo ? 'Editar Motivo' : 'Novo Motivo'}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Nome do Motivo *</Label>
              <Input value={motivoForm.nome} onChange={(e) => setMotivoForm({ nome: e.target.value })} data-testid="motivo-nome" />
            </div>
            <Button onClick={handleSaveMotivo} className="w-full bg-blue-600 hover:bg-blue-700" data-testid="save-motivo-btn">{editingMotivo ? 'Atualizar' : 'Salvar'}</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* TIPO DE EVENTO CREATE/EDIT DIALOG */}
      <Dialog open={tipoEventoDialog} onOpenChange={(v) => { setTipoEventoDialog(v); if (!v) resetTipoEventoForm(); }}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle>{editingTipoEvento ? 'Editar Tipo de Evento' : 'Novo Tipo de Evento'}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Nome do Tipo *</Label>
              <Input maxLength={16} value={tipoEventoForm.nome} onChange={(e) => setTipoEventoForm({ ...tipoEventoForm, nome: e.target.value })} data-testid="tipo-evento-nome" />
              <p className="text-xs text-slate-400 text-right mt-0.5">{tipoEventoForm.nome.length}/16</p>
            </div>
            <div>
              <Label>Fechamento em</Label>
              <div className="flex gap-2 mt-1">
                <Input type="number" min="0" placeholder="Ex: 2" value={tipoEventoForm.fechamento_valor} onChange={(e) => setTipoEventoForm({ ...tipoEventoForm, fechamento_valor: e.target.value })} className="flex-1" data-testid="tipo-evento-fechamento-valor" />
                <select value={tipoEventoForm.fechamento_unidade} onChange={(e) => setTipoEventoForm({ ...tipoEventoForm, fechamento_unidade: e.target.value })} className="px-3 py-2 border border-slate-200 rounded-md text-sm bg-white" data-testid="tipo-evento-fechamento-unidade">
                  <option value="horas">Horas</option>
                  <option value="dias">Dias</option>
                </select>
              </div>
              <p className="text-xs text-slate-500 mt-1">Tempo apos a data/hora do evento para fechamento automatico.</p>
            </div>
            <div className="space-y-3 border border-slate-200 rounded-lg p-3">
              <p className="text-sm font-medium text-slate-700">Contagens e campos extras</p>
              <label className="flex items-center gap-3 cursor-pointer" data-testid="tipo-evento-presidencia">
                <Switch checked={!!tipoEventoForm.tem_presidencia} onCheckedChange={(v) => setTipoEventoForm({ ...tipoEventoForm, tem_presidencia: v })} />
                <span className="text-sm text-slate-700">Tem presidencia?</span>
              </label>
              <label className="flex items-center gap-3 cursor-pointer" data-testid="tipo-evento-participantes">
                <Switch checked={!!tipoEventoForm.tem_participantes} onCheckedChange={(v) => setTipoEventoForm({ ...tipoEventoForm, tem_participantes: v })} />
                <div className="flex items-center gap-1.5">
                  <span className="text-sm text-slate-700">Tem contagem de participantes?</span>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild><Info className="w-3.5 h-3.5 text-slate-400" /></TooltipTrigger>
                      <TooltipContent><p className="text-xs max-w-[220px]">Tem evento que é importante ter a contagem total dos participantes. Para isso, marque esta opção.</p></TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
              </label>
              <label className="flex items-center gap-3 cursor-pointer" data-testid="tipo-evento-musicos">
                <Switch checked={!!tipoEventoForm.tem_musicos} onCheckedChange={(v) => setTipoEventoForm({ ...tipoEventoForm, tem_musicos: v })} />
                <span className="text-sm text-slate-700">Tem contagem de músicos?</span>
              </label>
              <label className="flex items-center gap-3 cursor-pointer" data-testid="tipo-evento-recitativos">
                <Switch checked={!!tipoEventoForm.tem_recitativos} onCheckedChange={(v) => setTipoEventoForm({ ...tipoEventoForm, tem_recitativos: v })} />
                <span className="text-sm text-slate-700">Tem contagem de recitativos?</span>
              </label>
              <label className="flex items-center gap-3 cursor-pointer" data-testid="tipo-evento-ministerio">
                <Switch checked={!!tipoEventoForm.tem_ministerio} onCheckedChange={(v) => setTipoEventoForm({ ...tipoEventoForm, tem_ministerio: v })} />
                <span className="text-sm text-slate-700">Tem contagem de ministério?</span>
              </label>
              <label className="flex items-center gap-3 cursor-pointer" data-testid="tipo-evento-material">
                <Switch checked={!!tipoEventoForm.eh_material} onCheckedChange={(v) => setTipoEventoForm({ ...tipoEventoForm, eh_material: v })} />
                <div className="flex items-center gap-1.5">
                  <span className="text-sm text-slate-700">É material?</span>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild><Info className="w-3.5 h-3.5 text-slate-400 cursor-default" /></TooltipTrigger>
                      <TooltipContent className="max-w-xs">
                        <p className="text-xs">Considera-se um evento material quando não envolve nenhum serviço oficial da Congregação Cristã no Brasil, tais como: Confraternizações, Tocatas, Boliche, Comer fora, etc.</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
              </label>
            </div>
            <div className="border border-slate-200 rounded-lg p-3">
              <label className="flex items-center gap-3 cursor-pointer" data-testid="tipo-evento-disponivel-reuniao">
                <Switch checked={!!tipoEventoForm.disponivel_reuniao} onCheckedChange={(v) => setTipoEventoForm({ ...tipoEventoForm, disponivel_reuniao: v })} />
                <div className="flex items-center gap-1.5">
                  <span className="text-sm text-slate-700">Disponível para Reuniões</span>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild><Info className="w-3.5 h-3.5 text-slate-400" /></TooltipTrigger>
                      <TooltipContent className="max-w-xs"><p className="text-xs">Quando marcado, este tipo aparecerá como opção ao criar uma nova Reunião.</p></TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
              </label>
            </div>
            <div className="border border-slate-200 rounded-lg p-3">
              <label className="flex items-center gap-3 cursor-pointer" data-testid="tipo-evento-permite-pessoa">
                <Switch checked={!!tipoEventoForm.permite_pessoa} onCheckedChange={(v) => setTipoEventoForm({ ...tipoEventoForm, permite_pessoa: v })} />
                <div className="flex items-center gap-1.5">
                  <span className="text-sm text-slate-700">Permite associar pessoa</span>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild><Info className="w-3.5 h-3.5 text-slate-400" /></TooltipTrigger>
                      <TooltipContent className="max-w-xs"><p className="text-xs">Quando marcado, ao criar um evento deste tipo será possível associar (opcionalmente) uma pessoa cadastrada ao evento.</p></TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
              </label>
            </div>
            {settings?.addons?.escalas && (
            <div className="border border-slate-200 rounded-lg p-3 space-y-3 mt-4">
              <label className="flex items-center gap-3 cursor-pointer" data-testid="tipo-evento-permite-escala">
                <Switch checked={!!tipoEventoForm.permite_escala_servicos} onCheckedChange={(v) => setTipoEventoForm({ ...tipoEventoForm, permite_escala_servicos: v, escalas_servico_ids: v ? serviceFunctions.filter(f => f.active).map(f => f.function_id) : [] })} />
                <div className="flex items-center gap-1.5">
                  <span className="text-sm text-slate-700">Permitir gerenciamento de serviços</span>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild><Info className="w-3.5 h-3.5 text-slate-400" /></TooltipTrigger>
                      <TooltipContent className="max-w-xs"><p className="text-xs">Ao ativar, selecione quais funções de serviço serão associadas a eventos deste tipo.</p></TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
              </label>
              {tipoEventoForm.permite_escala_servicos && (
                <div className="pl-7 space-y-2">
                  <Label className="text-xs text-slate-500">Escalas de serviços disponíveis *</Label>
                  {serviceFunctions.filter(f => f.active).length === 0 ? (
                    <p className="text-xs text-slate-400">Nenhuma função de serviço cadastrada. Configure em Configurações &gt; Escalas de Serviço.</p>
                  ) : (
                    <div className="flex flex-wrap gap-1.5" data-testid="escala-function-selector">
                      {serviceFunctions.filter(f => f.active).map(f => {
                        const selected = (tipoEventoForm.escalas_servico_ids || []).includes(f.function_id);
                        const elig = f.eligibility || {};
                        const genderColor = elig.gender === 'masculino' ? 'bg-blue-400' : elig.gender === 'feminino' ? 'bg-pink-400' : 'bg-slate-400';
                        const tooltipLines = [];
                        if (f.qty_male > 0) tooltipLines.push(`Meninos: ${f.qty_male}`);
                        if (f.qty_female > 0) tooltipLines.push(`Meninas: ${f.qty_female}`);
                        tooltipLines.push(`Gênero: ${elig.gender === 'masculino' ? 'Masculino' : elig.gender === 'feminino' ? 'Feminino' : 'Todos'}`);
                        if ((elig.idade_min > 0 || (elig.idade_max && elig.idade_max < 99))) tooltipLines.push(`Idade: ${elig.idade_min || 0} - ${elig.idade_max || 99} anos`);
                        if (elig.filtros_pessoa?.length > 0) tooltipLines.push(`Filtros: ${elig.filtros_pessoa.join(', ')}`);
                        else if (elig.apenas_auxiliares) tooltipLines.push('Apenas auxiliares');
                        return (
                          <TooltipProvider key={f.function_id}>
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <button type="button" onClick={() => {
                                  const ids = tipoEventoForm.escalas_servico_ids || [];
                                  setTipoEventoForm({ ...tipoEventoForm, escalas_servico_ids: selected ? ids.filter(id => id !== f.function_id) : [...ids, f.function_id] });
                                }} className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-xs font-medium border transition-colors ${selected ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-slate-200 text-slate-500 hover:border-slate-300'}`} data-testid={`escala-func-${f.function_id}`}>
                                  <span className={`w-2 h-2 rounded-full flex-shrink-0 ${genderColor}`} />
                                  {f.nome}
                                </button>
                              </TooltipTrigger>
                              <TooltipContent className="max-w-xs">
                                <div className="text-xs space-y-0.5">
                                  {tooltipLines.map((line, i) => <p key={i}>{line}</p>)}
                                </div>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>
            )}
            <div className="border border-slate-200 rounded-lg p-3 space-y-3">
              <label className="flex items-center gap-3 cursor-pointer" data-testid="tipo-evento-recorrencia">
                <Switch checked={!!tipoEventoForm.recorrencia_ativa} onCheckedChange={(v) => setTipoEventoForm({ ...tipoEventoForm, recorrencia_ativa: v })} />
                <div className="flex items-center gap-1.5">
                  <span className="text-sm text-slate-700">Evento Recorrente</span>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild><Info className="w-3.5 h-3.5 text-slate-400" /></TooltipTrigger>
                      <TooltipContent className="max-w-xs"><p className="text-xs">Ao ativar, o evento será criado automaticamente com base no dia, horário e frequência configurados. A criação ocorre ao abrir o sistema: até 60 minutos antes do horário previsto, ou retroativamente até 5 dias após a data, caso o sistema não tenha sido acessado a tempo. O nome do evento será o mesmo do tipo configurado.</p></TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
              </label>
              {tipoEventoForm.recorrencia_ativa && (
                <div className="space-y-2 pl-7">
                  <div className="flex gap-2">
                    <div className="flex-1">
                      <Label className="text-xs">Iniciando em</Label>
                      <Input type="date" value={tipoEventoForm.recorrencia_inicio || ''} onChange={(e) => setTipoEventoForm({ ...tipoEventoForm, recorrencia_inicio: e.target.value })} className="mt-1" data-testid="tipo-evento-recorrencia-inicio" />
                    </div>
                    <div className="flex-1">
                      <Label className="text-xs">Frequência</Label>
                      <select value={tipoEventoForm.recorrencia_frequencia} onChange={(e) => setTipoEventoForm({ ...tipoEventoForm, recorrencia_frequencia: e.target.value })} className="w-full px-3 py-2 border border-slate-200 rounded-md text-sm bg-white mt-1" data-testid="tipo-evento-recorrencia-frequencia">
                        <option value="semanal">Semanal</option>
                        <option value="quinzenal">Quinzenal</option>
                      </select>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <div className="flex-1">
                      <Label className="text-xs">Dia da semana</Label>
                      <select value={tipoEventoForm.recorrencia_dia_semana} onChange={(e) => setTipoEventoForm({ ...tipoEventoForm, recorrencia_dia_semana: e.target.value })} className="w-full px-3 py-2 border border-slate-200 rounded-md text-sm bg-white mt-1" data-testid="tipo-evento-recorrencia-dia">
                        <option value="">Selecione...</option>
                        <option value="0">Segunda-feira</option>
                        <option value="1">Terça-feira</option>
                        <option value="2">Quarta-feira</option>
                        <option value="3">Quinta-feira</option>
                        <option value="4">Sexta-feira</option>
                        <option value="5">Sábado</option>
                        <option value="6">Domingo</option>
                      </select>
                    </div>
                    <div className="flex-1">
                      <Label className="text-xs">Horário</Label>
                      <Input type="time" value={tipoEventoForm.recorrencia_horario} onChange={(e) => setTipoEventoForm({ ...tipoEventoForm, recorrencia_horario: e.target.value })} className="mt-1" data-testid="tipo-evento-recorrencia-horario" />
                    </div>
                  </div>
                  <div>
                    <Label className="text-xs">Criar evento com antecedência de</Label>
                    <div className="flex gap-2 mt-1">
                      <Input type="number" min="1" value={tipoEventoForm.recorrencia_antecedencia_valor || ''} onChange={(e) => setTipoEventoForm({ ...tipoEventoForm, recorrencia_antecedencia_valor: e.target.value })} placeholder="1" className="flex-1" data-testid="tipo-evento-antecedencia-valor" />
                      <select value={tipoEventoForm.recorrencia_antecedencia_unidade || 'horas'} onChange={(e) => setTipoEventoForm({ ...tipoEventoForm, recorrencia_antecedencia_unidade: e.target.value })} className="px-3 py-2 border border-slate-200 rounded-md text-sm bg-white" data-testid="tipo-evento-antecedencia-unidade">
                        <option value="minutos">Minutos</option>
                        <option value="horas">Horas</option>
                        <option value="dias">Dias</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="border border-slate-200 rounded-lg p-3 space-y-3">
              <div className="flex items-center gap-3" data-testid="tipo-evento-notificar-whatsapp">
                <Switch checked={!!tipoEventoForm.notificar_whatsapp} onCheckedChange={(checked) => {
                  if (checked) {
                    fetch(`${API}/evo/instance/status`, { credentials: 'include' })
                      .then(r => r.ok ? r.json() : null)
                      .then(d => {
                        if (d && (d?.instance?.state || d?.state) === 'open') {
                          setTipoEventoForm(prev => ({ ...prev, notificar_whatsapp: true }));
                        } else {
                          toast.error('WhatsApp não está conectado. Conecte em Complementos antes de ativar.');
                        }
                      })
                      .catch(() => toast.error('Não foi possível verificar o WhatsApp.'));
                  } else {
                    setTipoEventoForm(prev => ({ ...prev, notificar_whatsapp: false }));
                  }
                }} />
                <div className="flex items-center gap-1.5 flex-1">
                  <span className="text-sm text-slate-700">Notificar via WhatsApp</span>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild><Info className="w-3.5 h-3.5 text-slate-400" /></TooltipTrigger>
                      <TooltipContent className="max-w-xs"><p className="text-xs">Quando ativado, envia automaticamente uma mensagem via WhatsApp para todos os auxiliares 48h e 24h antes de cada evento deste tipo. A mensagem pode ser personalizada clicando na engrenagem.</p></TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
                {tipoEventoForm.notificar_whatsapp && (
                  <button type="button" onClick={() => setNotifMsgModal(true)} className="p-1.5 rounded-md hover:bg-slate-100 transition-colors" title="Personalizar mensagem">
                    <Settings className="w-4 h-4 text-slate-500" />
                  </button>
                )}
              </div>
            </div>
            <Button onClick={handleSaveTipoEvento} className="w-full bg-blue-600 hover:bg-blue-700" disabled={savingTipoEvento} data-testid="tipo-evento-save-btn">
              {savingTipoEvento ? 'Salvando...' : editingTipoEvento ? 'Atualizar' : 'Criar Tipo de Evento'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Personalizar Mensagem de Notificação */}
      <Dialog open={notifMsgModal} onOpenChange={setNotifMsgModal}>
        <DialogContent className="max-w-lg max-h-[85vh] flex flex-col p-0 sm:p-0 gap-0 overflow-hidden">
          <DialogHeader className="px-5 pt-5 pb-3 border-b border-slate-100 flex-shrink-0">
            <DialogTitle className="text-base flex items-center gap-2"><MessageSquare className="w-5 h-5 text-green-600" />Personalizar Mensagem</DialogTitle>
          </DialogHeader>
          <div className="flex-1 min-h-0 overflow-y-auto px-5 py-4 space-y-3">
            <p className="text-xs text-slate-500">Personalize a mensagem e escolha quando notificar os auxiliares.</p>
            <div>
              <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Quando notificar</p>
              <div className="flex items-center gap-3 flex-wrap">
                {[1, 2, 3, 5, 7].map(d => (
                  <label key={d} className="flex items-center gap-1.5 cursor-pointer text-xs text-slate-600">
                    <input type="checkbox" checked={(tipoEventoForm.notificacao_dias || []).includes(d)} onChange={(e) => {
                      setTipoEventoForm(prev => ({ ...prev, notificacao_dias: e.target.checked ? [...(prev.notificacao_dias || []), d].sort((a, b) => a - b) : (prev.notificacao_dias || []).filter(x => x !== d) }));
                    }} className="w-3.5 h-3.5 rounded border-slate-300 text-green-600 focus:ring-green-500" />
                    {d === 1 ? '1 dia antes' : `${d} dias antes`}
                  </label>
                ))}
              </div>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Variáveis disponíveis</p>
            <div className="flex flex-wrap gap-1.5">
              {[
                { key: '{nome_evento}', label: 'Nome do Evento' },
                { key: '{data}', label: 'Data' },
                { key: '{hora}', label: 'Hora' },
                { key: '{dia_semana}', label: 'Dia da Semana' },
                { key: '{tipo_evento}', label: 'Tipo de Evento' },
                { key: '{nome_igreja}', label: 'Nome da Igreja' },
                { key: '{tempo}', label: 'Amanhã / Em 2 dias' },
                { key: '{escala_evento}', label: 'Escala do Evento' },
              ].map(v => (
                <button key={v.key} type="button" onClick={() => setTipoEventoForm(prev => ({ ...prev, notificacao_msg: (prev.notificacao_msg || '') + v.key }))}
                  className="inline-flex items-center px-2 py-1 rounded-full border border-green-200 bg-green-50 text-green-700 text-[10px] font-medium hover:bg-green-100 transition-colors">
                  {v.label}
                </button>
              ))}
            </div>
            </div>
            <textarea value={tipoEventoForm.notificacao_msg} onChange={(e) => setTipoEventoForm({ ...tipoEventoForm, notificacao_msg: e.target.value })} rows={10}
              className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg bg-white resize-none focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" />
            <div className="bg-slate-50 rounded-lg p-3">
              <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider mb-1">Preview</p>
              <p className="text-sm text-slate-700 whitespace-pre-wrap">{(tipoEventoForm.notificacao_msg || '').replace('{nome_evento}', 'RJM Vila Arens').replace('{data}', '12/04/2026').replace('{hora}', '09:30').replace('{dia_semana}', 'sábado').replace('{tipo_evento}', tipoEventoForm.nome || 'Tipo').replace('{nome_igreja}', settings?.app_name || 'Igreja').replace('{tempo}', 'amanhã').replace('{escala_evento}', '*Meninos*\nJoão: 1ª Fila e Apoio na Oração\n\n*Meninas*\nMaria: 2ª Fila, Apoio na Oração e Contador')}</p>
            </div>
          </div>
          <div className="px-5 py-3 border-t border-slate-100 flex justify-end flex-shrink-0">
            <Button size="sm" className="bg-green-600 hover:bg-green-700" onClick={() => setNotifMsgModal(false)}>Salvar Mensagem</Button>
          </div>
        </DialogContent>
      </Dialog>


      <Dialog open={auditoriaDialog} onOpenChange={(open) => {
        setAuditoriaDialog(open);
        if (open) fetch(`${API}/audit-logs`, { credentials: 'include' }).then(r => r.ok ? r.json() : []).then(setAuditLogs).catch(() => {});
      }}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
          <AuditoriaTab auditLogs={auditLogs} onRefresh={() => fetch(`${API}/audit-logs`, { credentials: 'include' }).then(r => r.ok ? r.json() : []).then(setAuditLogs).catch(() => {})} />
        </DialogContent>
      </Dialog>

      <Dialog open={changelogDialog} onOpenChange={setChangelogDialog}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
          <ChangelogModal />
        </DialogContent>
      </Dialog>

      <Dialog open={calendarDisconnectDialog} onOpenChange={setCalendarDisconnectDialog}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle>Desconectar Google Agenda</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">Deseja mesmo se desconectar do Google Agenda? A agenda de aniversários será excluída da sua conta Google.</p>
          <div className="flex justify-end gap-2 mt-4">
            <Button variant="outline" size="sm" onClick={() => setCalendarDisconnectDialog(false)} disabled={calendarDisconnecting}>Cancelar</Button>
            <Button variant="destructive" size="sm" data-testid="confirm-calendar-disconnect" disabled={calendarDisconnecting}
              onClick={async () => {
                setCalendarDisconnecting(true);
                try {
                  await fetch(`${API}/calendar/disconnect`, { method: 'POST', credentials: 'include' });
                  setCalendarStatus({ connected: false, synced_count: 0 });
                  toast.success('Google Agenda desconectado');
                } catch { toast.error('Erro ao desconectar'); }
                setCalendarDisconnecting(false);
                setCalendarDisconnectDialog(false);
              }}>
              {calendarDisconnecting ? <><Loader2 className="w-4 h-4 animate-spin mr-1" />Desconectando...</> : 'Desconectar'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <OnboardingWizard
        open={onboardingOpen}
        onClose={async () => {
          setOnboardingOpen(false);
          try { await fetch(`${API}/auth/onboarding-complete`, { method: 'PUT', credentials: 'include' }); } catch {}
        }}
        onComplete={async () => {
          setOnboardingOpen(false);
          try { await fetch(`${API}/auth/onboarding-complete`, { method: 'PUT', credentials: 'include' }); } catch {}
        }}
      />

      {/* Info Modal — Motivos de Inativação */}
      <Dialog open={showMotivosInfo} onOpenChange={setShowMotivosInfo}>
        <DialogContent className="max-w-lg">
          <DialogHeader><DialogTitle className="text-base">Como funcionam os Motivos de Inativação?</DialogTitle></DialogHeader>
          <div className="space-y-3 text-sm text-slate-600">
            <div>
              <p className="font-semibold text-slate-800 mb-1">O que são motivos de inativação?</p>
              <p>São os motivos possíveis para inativar uma pessoa no sistema. Quando uma pessoa deixa de frequentar, muda de localidade, se casa ou por qualquer outro motivo precisa ser removida das listas ativas, o administrador seleciona o motivo correspondente.</p>
            </div>
            <div>
              <p className="font-semibold text-slate-800 mb-1">Como funciona?</p>
              <p>Ao inativar uma pessoa, você escolhe um motivo da lista. Isso permite gerar relatórios sobre os motivos de saída e manter um histórico organizado. A pessoa inativada deixa de aparecer em escalas, presenças e outras listagens ativas.</p>
            </div>
            <div>
              <p className="font-semibold text-slate-800 mb-1">Exemplos comuns</p>
              <p>"Deixou de frequentar", "Mudou para outra localidade", "Se casou", "Outro".</p>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Info Modal — Tipos de Evento */}
      <Dialog open={showTiposInfo} onOpenChange={setShowTiposInfo}>
        <DialogContent className="max-w-lg">
          <DialogHeader><DialogTitle className="text-base">Como funcionam os Tipos de Evento?</DialogTitle></DialogHeader>
          <div className="space-y-3 text-sm text-slate-600">
            <div>
              <p className="font-semibold text-slate-800 mb-1">O que são tipos de evento?</p>
              <p>Tipos de evento categorizam os eventos da igreja. Exemplos: "Culto de Mocidade", "Culto Oficial", "RJM Comum", "Visita". Cada tipo pode ter configurações específicas de contagem e funcionalidades.</p>
            </div>
            <div>
              <p className="font-semibold text-slate-800 mb-1">Configurações por tipo</p>
              <p>Cada tipo define: tempo de fechamento automático, se contabiliza presidência, participantes, hinos, recitativos, orações, atas e escalas de serviço. Essas flags controlam quais campos aparecem ao registrar um evento.</p>
            </div>
            <div>
              <p className="font-semibold text-slate-800 mb-1">Espiritual vs Material</p>
              <p>Tipos marcados como "Material" (ex: "Comes e Bebes") representam atividades de apoio, separadas dos cultos e reuniões espirituais na organização visual.</p>
            </div>
            <div>
              <p className="font-semibold text-slate-800 mb-1">Escalas de serviço</p>
              <p>Quando a flag "Escalas" está ativa num tipo de evento, ao criar um evento desse tipo o sistema gerará automaticamente uma escala de serviço com sugestões baseadas nas funções configuradas.</p>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* WhatsApp Deactivate Confirmation */}
      <AlertDialog open={evoDeactivateDialog} onOpenChange={setEvoDeactivateDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Desativar WhatsApp</AlertDialogTitle>
            <AlertDialogDescription>
              Tem certeza que deseja desativar o WhatsApp? A instância será desconectada e excluída. Todo envio de mensagens via WhatsApp será interrompido.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={() => { setEvoDeactivateDialog(false); handleEvoToggle(false); }} className="bg-red-600 hover:bg-red-700">
              Desativar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* WhatsApp QR Code Modal */}
      <Dialog open={evoQrModal} onOpenChange={setEvoQrModal}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle className="text-base flex items-center gap-2"><QrCode className="w-5 h-5" />Conectar WhatsApp</DialogTitle></DialogHeader>
          <div className="flex flex-col items-center gap-4 py-4">
            {evoQrLoading ? (
              <div className="flex flex-col items-center gap-3 py-8"><Loader2 className="w-8 h-8 animate-spin text-slate-400" /><p className="text-sm text-slate-500">Gerando QR Code...</p></div>
            ) : evoQrData ? (
              <>
                {typeof evoQrData === 'string' && evoQrData.startsWith('data:') ? (
                  <img src={evoQrData} alt="QR Code" className="w-48 h-48 rounded-lg" style={{ filter: 'contrast(1.5)' }} />
                ) : typeof evoQrData === 'object' && evoQrData.base64 ? (
                  <img src={evoQrData.base64} alt="QR Code" className="w-48 h-48 rounded-lg" style={{ filter: 'contrast(1.5)' }} />
                ) : (
                  <div className="bg-slate-50 rounded-lg p-4 text-center"><p className="text-sm text-slate-600 break-all">{typeof evoQrData === 'string' ? evoQrData : JSON.stringify(evoQrData)}</p></div>
                )}
                <div className="text-center space-y-1">
                  <p className="text-sm font-medium text-slate-700">Escaneie com o WhatsApp</p>
                  <p className="text-xs text-slate-400">WhatsApp &gt; Aparelhos conectados &gt; Conectar</p>
                </div>
                <Button size="sm" variant="outline" onClick={fetchEvoQR}><RefreshCw className="w-4 h-4 mr-1.5" />Gerar Novo QR</Button>
              </>
            ) : (
              <p className="text-sm text-slate-500 py-8">Nenhum QR Code disponível.</p>
            )}
          </div>
        </DialogContent>
      </Dialog>

      <Footer />
    </div>
  );
}

// End of AdminDashboard
